import React, { useState, Fragment, isValidElement, cloneElement, createElement, forwardRef, useLayoutEffect, useEffect, useCallback, useRef, createContext, useContext, useReducer, useMemo } from 'react';
var BannerContent = function (_a) {
  var children = _a.children;
  return React.createElement("div", {
    className: "banner__content-container"
  }, children);
};
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z$6 = ".banner__title {\n  position: relative;\n  z-index: 20;\n  margin-bottom: 0.5rem;\n  --tw-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--tw-text-opacity));\n}\n\n@media (min-width: 1024px) {\n  .banner__title {\n    margin-bottom: 1rem;\n    font-size: 3.75rem;\n    line-height: 4rem;\n  }\n}\n\n.banner_no-photo {\n  --tw-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n  padding-top: 1.25rem;\n  text-align: center\n}\n\n@media (min-width: 1024px) {\n  .banner_no-photo {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    text-align: left;\n  }\n}\n\n@media (min-width: 1024px) {\n  .banner_no-photo .banner_no-photo__container {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n}\n\n.banner_no-photo .banner_no-photo__title {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n  padding-bottom: 2rem;\n  font-family: Ubuntu, sans-serif;\n  font-size: 3rem;\n  line-height: 3.25rem;\n  font-weight: 700;\n  line-height: 1.25;\n  --tw-text-opacity: 1;\n  color: rgba(26, 26, 26, var(--tw-text-opacity));\n}\n\n@media (min-width: 1024px) {\n  .banner_no-photo .banner_no-photo__title {\n    grid-column-start: 1;\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n}\n\n.banner_no-photo .banner_no-photo__button {\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem;\n  flex-wrap: nowrap;\n}\n\n@media (min-width: 1024px) {\n  .banner__photo {\n    min-height: 470px;\n  }\n}\n\n.banner__photo {\n  position: relative;\n  z-index: 0;\n  margin-left: auto;\n  margin-right: auto;\n  overflow: hidden;\n  text-align: center;\n  --tw-text-opacity: 1;\n  color: rgba(255, 255, 255, var(--tw-text-opacity))\n}\n\n.banner__photo::before {\n  content: \"\";\n  /* top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0; */\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 10;\n  height: 100%;\n  width: 100%;\n  --tw-bg-opacity: 1;\n  background-color: rgba(68, 42, 36, var(--tw-bg-opacity));\n  --tw-bg-opacity: 0.7;\n}\n\n.banner__photo .banner__background-photo-wrapper {\n  position: absolute;\n  z-index: 0;\n  height: 100%;\n  width: 100%;\n  --tw-bg-opacity: 1;\n  background-color: rgba(68, 42, 36, var(--tw-bg-opacity));\n}\n\n.banner__photo .banner__background-photo {\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  object-fit: cover;\n  object-position: center;\n}\n\n.banner__photo .banner__content {\n  position: relative;\n  z-index: 20;\n  padding-top: 10rem;\n  padding-bottom: 10rem;\n}\n\n.banner__photo.banner_prose .banner__content {\n  position: relative;\n  padding-left: 3rem;\n  padding-right: 3rem;\n  text-align: left\n}\n\n@media (min-width: 768px) {\n  .banner__photo.banner_prose .banner__content {\n    width: 75%;\n  }\n}\n\n@media (min-width: 1024px) {\n  .banner__photo.banner_prose .banner__content {\n    width: 58.333333%;\n    padding-left: 0px;\n    padding-right: 0px;\n    padding-left: 8rem;\n  }\n}\n\n@media (min-width: 1280px) {\n  .banner__photo.banner_prose .banner__content {\n    width: 50%;\n  }\n}\n\n.banner__photo.banner_prose .banner__content .banner__button-container {\n  margin-top: 2rem;\n}\n\n@media (min-width: 1024px) {\n  .banner__photo.banner_prose .banner__content .banner__button-container {\n    margin-top: 4rem;\n  }\n}\n\n.banner__photo.banner_prose .banner__content .banner__content-container {\n  position: relative\n}\n\n.banner__photo.banner_prose .banner__content .banner__content-container::before {\n  content: \" \";\n  position: absolute;\n  top: -1.5rem;\n  z-index: 0;\n  display: inline-block;\n  height: 6rem;\n  width: 6rem;\n  border-radius: 9999px;\n  --tw-bg-opacity: 1;\n  background-color: rgba(105, 48, 195, var(--tw-bg-opacity));\n}\n\n@media (min-width: 1024px) {\n  .banner__photo.banner_prose .banner__content .banner__content-container::before {\n    top: -1rem;\n    left: -6rem;\n    margin-left: 16rem;\n  }\n}\n\n.banner__photo.banner_prose .banner__content .banner__content-container p {\n  position: relative;\n  z-index: 20;\n  margin-top: 2rem;\n  margin-right: 1.5rem;\n  margin-left: 4rem;\n  font-family: Ubuntu, sans-serif;\n  font-size: .875rem;\n  line-height: 1.125rem;\n}\n\n@media (min-width: 1024px) {\n  .banner__photo.banner_prose .banner__content .banner__content-container p {\n    margin-top: 0px;\n    margin-left: 16rem;\n    font-size: 2.25rem;\n    line-height: 2.4rem;\n    font-weight: 700;\n  }\n}\n\n.banner_device {\n  margin-bottom: 24rem;\n  --tw-bg-opacity: 1;\n  background-color: rgba(44, 203, 192, var(--tw-bg-opacity));\n  padding-top: 5rem;\n  text-align: center;\n  height: 725px\n}\n\n@media (min-width: 1024px) {\n  .banner_device .banner_device__container {\n    margin-left: auto;\n    margin-right: auto;\n    display: grid;\n    max-width: 1280px;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.banner_device .banner_device__container .banner__content-container {\n  width: 100%;\n}\n\n@media (min-width: 1024px) {\n  .banner_device .banner_device__container .banner__content-container {\n    margin-top: 5rem;\n  }\n}\n\n.banner_device .banner_device__container .banner_device__title {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n  padding-top: 2.5rem;\n  padding-bottom: 2rem;\n  text-align: left;\n  font-family: Ubuntu, sans-serif;\n  font-size: 3rem;\n  line-height: 3.25rem;\n  font-weight: 700;\n  line-height: 1.25;\n  --tw-text-opacity: 1;\n  color: rgba(26, 26, 26, var(--tw-text-opacity));\n}\n\n@media (min-width: 1024px) {\n  .banner_device .banner_device__container .banner_device__container {\n    display: flex;\n    flex-wrap: nowrap;\n  }\n}\n\n.banner_device .banner_device__container .banner_device__container div:first-child {\n  margin-bottom: 2.5rem;\n}\n\n@media (min-width: 1024px) {\n  .banner_device .banner_device__container .banner_device__container .hero__button-container {\n    margin-right: 1.25rem;\n  }\n}\n\n.banner_device .banner_device__container .banner_device__device-container {\n  margin-top: 5rem;\n  width: 100%;\n}\n\n@media (min-width: 1024px) {\n  .banner_device {\n    height: 625px;\n    margin-bottom: 5rem;\n    width: 100%;\n    overflow: hidden;\n    padding-top: 5rem\n  }\n\n  .banner_device .banner_device__container .banner_device__device-container {\n    margin-top: 0px;\n    width: 100%;\n  }\n\n  .banner_device .marvel-device.iphone-x .speaker {\n    display: none;\n  }\n}\n";
styleInject(css_248z$6);
var BannerTitle = function (_a) {
  var children = _a.children;
  return React.createElement("h3", {
    className: "banner__title"
  }, children);
}; //note: we are deprecating backgroundImageUrl in
//favor of backgroundImageProps for responsive images
var SimpleBanner = function (_a) {
  var children = _a.children,
    BackgroundImage = _a.BackgroundImage,
    type = _a.type,
    style = _a.style;
  return React.createElement("section", {
    className: "banner__photo banner_".concat(type),
    style: style
  }, BackgroundImage && React.createElement("div", {
    className: "banner__background-photo-wrapper"
  }, React.createElement(BackgroundImage, {
    className: "banner__background-photo"
  })), React.createElement("div", {
    className: "banner__content"
  }, children));
}; /*!
   * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
   * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
   */

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    });
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
var noop = function noop() {};
var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};
try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}
var _ref = _WINDOW.navigator || {},
  _ref$userAgent = _ref.userAgent,
  userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var PERFORMANCE = _PERFORMANCE;
!!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');
var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
(function () {
  try {
    return process.env.NODE_ENV === 'production';
  } catch (e) {
    return false;
  }
})();
var DUOTONE_CLASSES = {
  GROUP: 'group',
  SWAP_OPACITY: 'swap-opacity',
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
var initial = WINDOW.FontAwesomeConfig || {};
function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');
  if (element) {
    return element.getAttribute(attr);
  }
}
function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  // For example <script data-search-pseudo-elements src="..."></script>
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}
if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-mutate-approach', 'mutateApproach'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];
  attrs.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      attr = _ref2[0],
      key = _ref2[1];
    var val = coerce(getAttrConfig(attr));
    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}
var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: 'async',
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};
var _config = _objectSpread({}, _default, initial);
if (!_config.autoReplaceSvg) _config.observeMutations = false;
var config = _objectSpread({}, _config);
WINDOW.FontAwesomeConfig = config;
var w$1 = WINDOW || {};
if (!w$1[NAMESPACE_IDENTIFIER]) w$1[NAMESPACE_IDENTIFIER] = {};
if (!w$1[NAMESPACE_IDENTIFIER].styles) w$1[NAMESPACE_IDENTIFIER].styles = {};
if (!w$1[NAMESPACE_IDENTIFIER].hooks) w$1[NAMESPACE_IDENTIFIER].hooks = {};
if (!w$1[NAMESPACE_IDENTIFIER].shims) w$1[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w$1[NAMESPACE_IDENTIFIER];
var functions = [];
var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};
var loaded = false;
if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}
typeof global !== 'undefined' && typeof global.process !== 'undefined' && typeof global.process.emit === 'function';
typeof setImmediate === 'undefined' ? setTimeout : setImmediate;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }
  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;
  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();
    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }
  DOCUMENT.head.insertBefore(style, beforeChild);
  return css;
}
var idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function nextUniqueId() {
  var size = 12;
  var id = '';
  while (size-- > 0) {
    id += idPool[Math.random() * 62 | 0];
  }
  return id;
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + "".concat(attributeName, "=\"").concat(htmlEscape(attributes[attributeName]), "\" ");
  }, '').trim();
}
function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
  }, '');
}
function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function transformForSvg(_ref) {
  var transform = _ref.transform,
    containerWidth = _ref.containerWidth,
    iconWidth = _ref.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
  var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
  var inner = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}
var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};
function fillBlack(_abstract) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (_abstract.attributes && (_abstract.attributes.fill || force)) {
    _abstract.attributes.fill = 'black';
  }
  return _abstract;
}
function deGroup(_abstract2) {
  if (_abstract2.tag === 'g') {
    return _abstract2.children;
  } else {
    return [_abstract2];
  }
}
function makeIconMasking(_ref) {
  var children = _ref.children,
    attributes = _ref.attributes,
    main = _ref.main,
    mask = _ref.mask,
    explicitMaskId = _ref.maskId,
    transform = _ref.transform;
  var mainWidth = main.width,
    mainPath = main.icon;
  var maskWidth = mask.width,
    maskPath = mask.icon;
  var trans = transformForSvg({
    transform: transform,
    containerWidth: maskWidth,
    iconWidth: mainWidth
  });
  var maskRect = {
    tag: 'rect',
    attributes: _objectSpread({}, ALL_SPACE, {
      fill: 'white'
    })
  };
  var maskInnerGroupChildrenMixin = mainPath.children ? {
    children: mainPath.children.map(fillBlack)
  } : {};
  var maskInnerGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.inner),
    children: [fillBlack(_objectSpread({
      tag: mainPath.tag,
      attributes: _objectSpread({}, mainPath.attributes, trans.path)
    }, maskInnerGroupChildrenMixin))]
  };
  var maskOuterGroup = {
    tag: 'g',
    attributes: _objectSpread({}, trans.outer),
    children: [maskInnerGroup]
  };
  var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
  var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
  var maskTag = {
    tag: 'mask',
    attributes: _objectSpread({}, ALL_SPACE, {
      id: maskId,
      maskUnits: 'userSpaceOnUse',
      maskContentUnits: 'userSpaceOnUse'
    }),
    children: [maskRect, maskOuterGroup]
  };
  var defs = {
    tag: 'defs',
    children: [{
      tag: 'clipPath',
      attributes: {
        id: clipId
      },
      children: deGroup(maskPath)
    }, maskTag]
  };
  children.push(defs, {
    tag: 'rect',
    attributes: _objectSpread({
      fill: 'currentColor',
      'clip-path': "url(#".concat(clipId, ")"),
      mask: "url(#".concat(maskId, ")")
    }, ALL_SPACE)
  });
  return {
    children: children,
    attributes: attributes
  };
}
function makeIconStandard(_ref) {
  var children = _ref.children,
    attributes = _ref.attributes,
    main = _ref.main,
    transform = _ref.transform,
    styles = _ref.styles;
  var styleString = joinStyles(styles);
  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }
  if (transformIsMeaningful(transform)) {
    var trans = transformForSvg({
      transform: transform,
      containerWidth: main.width,
      iconWidth: main.width
    });
    children.push({
      tag: 'g',
      attributes: _objectSpread({}, trans.outer),
      children: [{
        tag: 'g',
        attributes: _objectSpread({}, trans.inner),
        children: [{
          tag: main.icon.tag,
          children: main.icon.children,
          attributes: _objectSpread({}, main.icon.attributes, trans.path)
        }]
      }]
    });
  } else {
    children.push(main.icon);
  }
  return {
    children: children,
    attributes: attributes
  };
}
function asIcon(_ref) {
  var children = _ref.children,
    main = _ref.main,
    mask = _ref.mask,
    attributes = _ref.attributes,
    styles = _ref.styles,
    transform = _ref.transform;
  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
      height = main.height;
    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_objectSpread({}, styles, {
      'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
    }));
  }
  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
}
function asSymbol(_ref) {
  var prefix = _ref.prefix,
    iconName = _ref.iconName,
    children = _ref.children,
    attributes = _ref.attributes,
    symbol = _ref.symbol;
  var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _objectSpread({}, attributes, {
        id: id
      }),
      children: children
    }]
  }];
}
function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
    main = _params$icons.main,
    mask = _params$icons.mask,
    prefix = params.prefix,
    iconName = params.iconName,
    transform = params.transform,
    symbol = params.symbol,
    title = params.title,
    maskId = params.maskId,
    titleId = params.titleId,
    extra = params.extra,
    _params$watchable = params.watchable,
    watchable = _params$watchable === void 0 ? false : _params$watchable;
  var _ref = mask.found ? mask : main,
    width = _ref.width,
    height = _ref.height;
  var isUploadedIcon = prefix === 'fak';
  var widthClass = isUploadedIcon ? '' : "fa-w-".concat(Math.ceil(width / height * 16));
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : '', widthClass].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function (c) {
    return c !== '' || !!c;
  }).concat(extra.classes).join(' ');
  var content = {
    children: [],
    attributes: _objectSpread({}, extra.attributes, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': extra.attributes.role || 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': "0 0 ".concat(width, " ").concat(height)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
    width: "".concat(width / height * 16 * 0.0625, "em")
  } : {};
  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }
  if (title) content.children.push({
    tag: 'title',
    attributes: {
      id: content.attributes['aria-labelledby'] || "title-".concat(titleId || nextUniqueId())
    },
    children: [title]
  });
  var args = _objectSpread({}, content, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    maskId: maskId,
    transform: transform,
    symbol: symbol,
    styles: _objectSpread({}, uploadedIconWidthStyle, extra.styles)
  });
  var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args),
    children = _ref2.children,
    attributes = _ref2.attributes;
  args.children = children;
  args.attributes = attributes;
  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
var noop$1 = function noop() {};
config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */

var bindInternal4 = function bindInternal4(func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */

var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
    length = keys.length,
    iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
    i,
    key,
    result;
  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  } else {
    i = 0;
    result = initialValue;
  }
  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }
  return result;
};
function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks,
    skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;
    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }
    return acc;
  }, {});
  if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
    namespace.hooks.addPack(prefix, normalized);
  } else {
    namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
  }
  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */

  if (prefix === 'fas') {
    defineIcons('fa', icons);
  }
}
var styles = namespace.styles,
  shims = namespace.shims;
var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };
  lookup(function (acc, icon, iconName) {
    if (icon[3]) {
      acc[icon[3]] = iconName;
    }
    return acc;
  });
  lookup(function (acc, icon, iconName) {
    var ligatures = icon[2];
    acc[iconName] = iconName;
    ligatures.forEach(function (ligature) {
      acc[ligature] = iconName;
    });
    return acc;
  });
  var hasRegular = ('far' in styles);
  reduce(shims, function (acc, shim) {
    var oldName = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];
    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }
    acc[oldName] = {
      prefix: prefix,
      iconName: iconName
    };
    return acc;
  }, {});
};
build();
namespace.styles;
function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}
function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
    _abstractNodes$attrib = abstractNodes.attributes,
    attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib,
    _abstractNodes$childr = abstractNodes.children,
    children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(''), "</").concat(tag, ">");
  }
}
var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  if (!transformString) {
    return transform;
  } else {
    return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
      var parts = n.toLowerCase().split('-');
      var first = parts[0];
      var rest = parts.slice(1).join('-');
      if (first && rest === 'h') {
        acc.flipX = true;
        return acc;
      }
      if (first && rest === 'v') {
        acc.flipY = true;
        return acc;
      }
      rest = parseFloat(rest);
      if (isNaN(rest)) {
        return acc;
      }
      switch (first) {
        case 'grow':
          acc.size = acc.size + rest;
          break;
        case 'shrink':
          acc.size = acc.size - rest;
          break;
        case 'left':
          acc.x = acc.x - rest;
          break;
        case 'right':
          acc.x = acc.x + rest;
          break;
        case 'up':
          acc.y = acc.y - rest;
          break;
        case 'down':
          acc.y = acc.y + rest;
          break;
        case 'rotate':
          acc.rotate = acc.rotate + rest;
          break;
      }
      return acc;
    }, transform);
  }
};
function MissingIcon(error) {
  this.name = 'MissingIcon';
  this.message = error || 'Icon unavailable';
  this.stack = new Error().stack;
}
MissingIcon.prototype = Object.create(Error.prototype);
MissingIcon.prototype.constructor = MissingIcon;
var FILL = {
  fill: 'currentColor'
};
var ANIMATION_BASE = {
  attributeType: 'XML',
  repeatCount: 'indefinite',
  dur: '2s'
};
({
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
  })
});
var OPACITY_ANIMATE = _objectSpread({}, ANIMATION_BASE, {
  attributeName: 'opacity'
});
({
  tag: 'circle',
  attributes: _objectSpread({}, FILL, {
    cx: '256',
    cy: '364',
    r: '28'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, ANIMATION_BASE, {
      attributeName: 'r',
      values: '28;14;28;28;14;28;'
    })
  }, {
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;1;1;0;1;'
    })
  }]
});
({
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '1',
    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '1;0;0;0;0;1;'
    })
  }]
});
({
  tag: 'path',
  attributes: _objectSpread({}, FILL, {
    opacity: '0',
    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
  }),
  children: [{
    tag: 'animate',
    attributes: _objectSpread({}, OPACITY_ANIMATE, {
      values: '0;0;1;1;0;0;'
    })
  }]
});
namespace.styles;
function asFoundIcon(icon) {
  var width = icon[0];
  var height = icon[1];
  var _icon$slice = icon.slice(4),
    _icon$slice2 = _slicedToArray(_icon$slice, 1),
    vectorData = _icon$slice2[0];
  var element = null;
  if (Array.isArray(vectorData)) {
    element = {
      tag: 'g',
      attributes: {
        "class": "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: 'path',
        attributes: {
          "class": "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: 'currentColor',
          d: vectorData[0]
        }
      }, {
        tag: 'path',
        attributes: {
          "class": "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: 'currentColor',
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: 'path',
      attributes: {
        fill: 'currentColor',
        d: vectorData
      }
    };
  }
  return {
    found: true,
    width: width,
    height: height,
    icon: element
  };
}
namespace.styles;
var baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}";
function css() {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;
  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), 'g');
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), 'g');
    var rPatt = new RegExp("\\.".concat(drc), 'g');
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
  }
  return s;
}
var Library = /*#__PURE__*/function () {
  function Library() {
    _classCallCheck(this, Library);
    this.definitions = {};
  }
  _createClass(Library, [{
    key: "add",
    value: function add() {
      var _this = this;
      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }
      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _objectSpread({}, _this.definitions[key] || {}, additions[key]);
        defineIcons(key, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
          prefix = _normalized$key.prefix,
          iconName = _normalized$key.iconName,
          icon = _normalized$key.icon;
        if (!additions[prefix]) additions[prefix] = {};
        additions[prefix][iconName] = icon;
      });
      return additions;
    }
  }]);
  return Library;
}();
function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}
function apiObject(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });
  Object.defineProperty(val, 'html', {
    get: function get() {
      return val["abstract"].map(function (a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;
      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });
  return val;
}
function findIconDefinition(iconLookup) {
  var _iconLookup$prefix = iconLookup.prefix,
    prefix = _iconLookup$prefix === void 0 ? 'fa' : _iconLookup$prefix,
    iconName = iconLookup.iconName;
  if (!iconName) return;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;
    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }
    return next(iconDefinition, _objectSpread({}, params, {
      mask: mask
    }));
  };
}
var library = new Library();
var _cssInserted = false;
var parse = {
  transform: function transform(transformString) {
    return parseTransformString(transformString);
  }
};
var icon = resolveIcons(function (iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
    transform = _params$transform === void 0 ? meaninglessTransform : _params$transform,
    _params$symbol = params.symbol,
    symbol = _params$symbol === void 0 ? false : _params$symbol,
    _params$mask = params.mask,
    mask = _params$mask === void 0 ? null : _params$mask,
    _params$maskId = params.maskId,
    maskId = _params$maskId === void 0 ? null : _params$maskId,
    _params$title = params.title,
    title = _params$title === void 0 ? null : _params$title,
    _params$titleId = params.titleId,
    titleId = _params$titleId === void 0 ? null : _params$titleId,
    _params$classes = params.classes,
    classes = _params$classes === void 0 ? [] : _params$classes,
    _params$attributes = params.attributes,
    attributes = _params$attributes === void 0 ? {} : _params$attributes,
    _params$styles = params.styles,
    styles = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition) return;
  var prefix = iconDefinition.prefix,
    iconName = iconDefinition.iconName,
    icon = iconDefinition.icon;
  return apiObject(_objectSpread({
    type: 'icon'
  }, iconDefinition), function () {
    ensureCss();
    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes['aria-hidden'] = 'true';
        attributes['focusable'] = 'false';
      }
    }
    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _objectSpread({}, meaninglessTransform, transform),
      symbol: symbol,
      title: title,
      maskId: maskId,
      titleId: titleId,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
});
var propTypes = {
  exports: {}
};
var reactIs = {
  exports: {}
};
var reactIs_production_min = {}; /** @license React v16.13.1
                                 * react-is.production.min.js
                                 *
                                 * Copyright (c) Facebook, Inc. and its affiliates.
                                 *
                                 * This source code is licensed under the MIT license found in the
                                 * LICENSE file in the root directory of this source tree.
                                 */

var b = "function" === typeof Symbol && Symbol["for"],
  c = b ? Symbol["for"]("react.element") : 60103,
  d = b ? Symbol["for"]("react.portal") : 60106,
  e = b ? Symbol["for"]("react.fragment") : 60107,
  f = b ? Symbol["for"]("react.strict_mode") : 60108,
  g = b ? Symbol["for"]("react.profiler") : 60114,
  h = b ? Symbol["for"]("react.provider") : 60109,
  k = b ? Symbol["for"]("react.context") : 60110,
  l = b ? Symbol["for"]("react.async_mode") : 60111,
  m = b ? Symbol["for"]("react.concurrent_mode") : 60111,
  n = b ? Symbol["for"]("react.forward_ref") : 60112,
  p = b ? Symbol["for"]("react.suspense") : 60113,
  q = b ? Symbol["for"]("react.suspense_list") : 60120,
  r = b ? Symbol["for"]("react.memo") : 60115,
  t = b ? Symbol["for"]("react.lazy") : 60116,
  v = b ? Symbol["for"]("react.block") : 60121,
  w = b ? Symbol["for"]("react.fundamental") : 60117,
  x = b ? Symbol["for"]("react.responder") : 60118,
  y = b ? Symbol["for"]("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
reactIs_production_min.AsyncMode = l;
reactIs_production_min.ConcurrentMode = m;
reactIs_production_min.ContextConsumer = k;
reactIs_production_min.ContextProvider = h;
reactIs_production_min.Element = c;
reactIs_production_min.ForwardRef = n;
reactIs_production_min.Fragment = e;
reactIs_production_min.Lazy = t;
reactIs_production_min.Memo = r;
reactIs_production_min.Portal = d;
reactIs_production_min.Profiler = g;
reactIs_production_min.StrictMode = f;
reactIs_production_min.Suspense = p;
reactIs_production_min.isAsyncMode = function (a) {
  return A(a) || z(a) === l;
};
reactIs_production_min.isConcurrentMode = A;
reactIs_production_min.isContextConsumer = function (a) {
  return z(a) === k;
};
reactIs_production_min.isContextProvider = function (a) {
  return z(a) === h;
};
reactIs_production_min.isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
reactIs_production_min.isForwardRef = function (a) {
  return z(a) === n;
};
reactIs_production_min.isFragment = function (a) {
  return z(a) === e;
};
reactIs_production_min.isLazy = function (a) {
  return z(a) === t;
};
reactIs_production_min.isMemo = function (a) {
  return z(a) === r;
};
reactIs_production_min.isPortal = function (a) {
  return z(a) === d;
};
reactIs_production_min.isProfiler = function (a) {
  return z(a) === g;
};
reactIs_production_min.isStrictMode = function (a) {
  return z(a) === f;
};
reactIs_production_min.isSuspense = function (a) {
  return z(a) === p;
};
reactIs_production_min.isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
reactIs_production_min.typeOf = z;
var reactIs_development = {}; /** @license React v16.13.1
                              * react-is.development.js
                              *
                              * Copyright (c) Facebook, Inc. and its affiliates.
                              *
                              * This source code is licensed under the MIT license found in the
                              * LICENSE file in the root directory of this source tree.
                              */

if (process.env.NODE_ENV !== "production") {
  (function () {
    // nor polyfill, then a plain number is used for performance.

    var hasSymbol = typeof Symbol === 'function' && Symbol["for"];
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol["for"]('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol["for"]('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol["for"]('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol["for"]('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol["for"]('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol["for"]('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?

    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol["for"]('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol["for"]('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol["for"]('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol["for"]('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol["for"]('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol["for"]('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol["for"]('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol["for"]('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol["for"]('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol["for"]('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol["for"]('react.scope') : 0xead7;
    function isValidElementType(type) {
      return typeof type === 'string' || typeof type === 'function' ||
      // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
      if (typeof object === 'object' && object !== null) {
        var $$typeof = object.$$typeof;
        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object.type;
            switch (type) {
              case REACT_ASYNC_MODE_TYPE:
              case REACT_CONCURRENT_MODE_TYPE:
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
                return type;
              default:
                var $$typeofType = type && type.$$typeof;
                switch ($$typeofType) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;
                  default:
                    return $$typeof;
                }
            }
          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }
      return undefined;
    } // AsyncMode is deprecated along with isAsyncMode

    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

    function isAsyncMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
        }
      }
      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
      return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    reactIs_development.AsyncMode = AsyncMode;
    reactIs_development.ConcurrentMode = ConcurrentMode;
    reactIs_development.ContextConsumer = ContextConsumer;
    reactIs_development.ContextProvider = ContextProvider;
    reactIs_development.Element = Element;
    reactIs_development.ForwardRef = ForwardRef;
    reactIs_development.Fragment = Fragment;
    reactIs_development.Lazy = Lazy;
    reactIs_development.Memo = Memo;
    reactIs_development.Portal = Portal;
    reactIs_development.Profiler = Profiler;
    reactIs_development.StrictMode = StrictMode;
    reactIs_development.Suspense = Suspense;
    reactIs_development.isAsyncMode = isAsyncMode;
    reactIs_development.isConcurrentMode = isConcurrentMode;
    reactIs_development.isContextConsumer = isContextConsumer;
    reactIs_development.isContextProvider = isContextProvider;
    reactIs_development.isElement = isElement;
    reactIs_development.isForwardRef = isForwardRef;
    reactIs_development.isFragment = isFragment;
    reactIs_development.isLazy = isLazy;
    reactIs_development.isMemo = isMemo;
    reactIs_development.isPortal = isPortal;
    reactIs_development.isProfiler = isProfiler;
    reactIs_development.isStrictMode = isStrictMode;
    reactIs_development.isSuspense = isSuspense;
    reactIs_development.isValidElementType = isValidElementType;
    reactIs_development.typeOf = typeOf;
  })();
}
if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
} /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118

    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056

    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056

    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
}; /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$3; /**
                                                     * Copyright (c) 2013-present, Facebook, Inc.
                                                     *
                                                     * This source code is licensed under the MIT license found in the
                                                     * LICENSE file in the root directory of this source tree.
                                                     */

var printWarning$1 = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
  printWarning$1 = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */

function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */

checkPropTypes$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes$1; /**
                                         * Copyright (c) 2013-present, Facebook, Inc.
                                         *
                                         * This source code is licensed under the MIT license found in the
                                         * LICENSE file in the root directory of this source tree.
                                         */

var ReactIs$1 = reactIs.exports;
var assign = objectAssign;
var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var checkPropTypes = checkPropTypes_1;
var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function printWarning() {};
if (process.env.NODE_ENV !== 'production') {
  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */

  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.

  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] &&
          // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1) == null) {
          return null;
        }
      }
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.

      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol

    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'

    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.

    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.

  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.

  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"

  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  } // Returns class name of the object, if any.

  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
}; /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

var ReactPropTypesSecret = ReactPropTypesSecret_1;
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
}; /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs.exports; // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod

  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}
var PropTypes = propTypes.exports;
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
}
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
} // Get CSS class list from a props object

function classList(props) {
  var _classes;
  var spin = props.spin,
    pulse = props.pulse,
    fixedWidth = props.fixedWidth,
    inverse = props.inverse,
    border = props.border,
    listItem = props.listItem,
    flip = props.flip,
    size = props.size,
    rotation = props.rotation,
    pull = props.pull; // map of CSS class names to properties

  var classes = (_classes = {
    'fa-spin': spin,
    'fa-pulse': pulse,
    'fa-fw': fixedWidth,
    'fa-inverse': inverse,
    'fa-border': border,
    'fa-li': listItem,
    'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
    'fa-flip-vertical': flip === 'vertical' || flip === 'both'
  }, _defineProperty(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), _defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), _defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), _defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
  // return an array of the keys where the value for the key is not null

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
} // Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number

function _isNumerical(obj) {
  obj = obj - 0; // eslint-disable-next-line no-self-compare

  return obj === obj;
}
function camelize(string) {
  if (_isNumerical(string)) {
    return string;
  } // eslint-disable-next-line no-useless-escape

  string = string.replace(/[\-_\s]+(.)?/g, function (match, chr) {
    return chr ? chr.toUpperCase() : '';
  }); // Ensure 1st char is always lowercase

  return string.substr(0, 1).toLowerCase() + string.substr(1);
}
function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}
function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}
function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (typeof element === 'string') {
    return element;
  }
  var children = (element.children || []).map(function (child) {
    return convert(createElement, child);
  });
  /* eslint-disable dot-notation */

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];
    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;
      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;
      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }
    }
    return acc;
  }, {
    attrs: {}
  });
  var _extraProps$style = extraProps.style,
    existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style,
    remaining = _objectWithoutProperties(extraProps, ["style"]);
  mixins.attrs['style'] = _objectSpread2({}, mixins.attrs['style'], {}, existingStyle);
  /* eslint-enable */

  return createElement.apply(void 0, [element.tag, _objectSpread2({}, mixins.attrs, {}, remaining)].concat(_toConsumableArray(children)));
}
var PRODUCTION = false;
try {
  PRODUCTION = process.env.NODE_ENV === 'production';
} catch (e) {}
function log() {
  if (!PRODUCTION && console && typeof console.error === 'function') {
    var _console;
    (_console = console).error.apply(_console, arguments);
  }
}
function normalizeIconArgs(icon) {
  // this has everything that it needs to be rendered which means it was probably imported
  // directly from an icon svg package
  if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) {
    return icon;
  }
  if (icon === null) {
    return null;
  } // if the icon is an object and has a prefix and an icon name, return it

  if (icon && _typeof(icon) === 'object' && icon.prefix && icon.iconName) {
    return icon;
  } // if it's an array with length of two

  if (Array.isArray(icon) && icon.length === 2) {
    // use the first item as prefix, second as icon name
    return {
      prefix: icon[0],
      iconName: icon[1]
    };
  } // if it's a string, use it as the icon name

  if (typeof icon === 'string') {
    return {
      prefix: 'fas',
      iconName: icon
    };
  }
} // creates an object with a key of key
// and a value of value
// if certain conditions are met

function objectWithKey(key, value) {
  // if the value is a non-empty array
  // or it's not an array but it is truthy
  // then create the object with the key and the value
  // if not, return an empty array
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty({}, key, value) : {};
}
function FontAwesomeIcon(_ref) {
  var forwardedRef = _ref.forwardedRef,
    props = _objectWithoutProperties(_ref, ["forwardedRef"]);
  var iconArgs = props.icon,
    maskArgs = props.mask,
    symbol = props.symbol,
    className = props.className,
    title = props.title,
    titleId = props.titleId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(_toConsumableArray(classList(props)), _toConsumableArray(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? parse.transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
  var renderedIcon = icon(iconLookup, _objectSpread2({}, classes, {}, transform, {}, mask, {
    symbol: symbol,
    title: title,
    titleId: titleId
  }));
  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }
  var _abstract = renderedIcon["abstract"];
  var extraProps = {
    ref: forwardedRef
  };
  Object.keys(props).forEach(function (key) {
    // eslint-disable-next-line no-prototype-builtins
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(_abstract[0], extraProps);
}
FontAwesomeIcon.displayName = 'FontAwesomeIcon';
FontAwesomeIcon.propTypes = {
  border: PropTypes.bool,
  className: PropTypes.string,
  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  fixedWidth: PropTypes.bool,
  inverse: PropTypes.bool,
  flip: PropTypes.oneOf(['horizontal', 'vertical', 'both']),
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  listItem: PropTypes.bool,
  pull: PropTypes.oneOf(['right', 'left']),
  pulse: PropTypes.bool,
  rotation: PropTypes.oneOf([0, 90, 180, 270]),
  size: PropTypes.oneOf(['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
  spin: PropTypes.bool,
  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.string,
  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  swapOpacity: PropTypes.bool
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: '',
  mask: null,
  fixedWidth: false,
  inverse: false,
  flip: null,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  symbol: false,
  title: '',
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, React.createElement);
var Button$1 = function (_a) {
  var text = _a.text,
    children = _a.children,
    to = _a.to,
    onClick = _a.onClick,
    _b = _a.size,
    size = _b === void 0 ? "lg" : _b,
    _c = _a.secondary,
    secondary = _c === void 0 ? false : _c,
    placement = _a.placement,
    icon = _a.icon,
    _d = _a.iconSize,
    iconSize = _d === void 0 ? "1x" : _d,
    _e = _a.className,
    className = _e === void 0 ? "" : _e,
    _f = _a.hideText,
    hideText = _f === void 0 ? false : _f;
  var modifiers = [];
  if (secondary) {
    modifiers.push("button_secondary");
  }
  if (placement === "banner") {
    modifiers.push("banner__button");
  } else if (placement === "photo") {
    modifiers.push("banner-photo__button");
  }
  var faIcon;
  if (icon) {
    faIcon = React.createElement(FontAwesomeIcon, {
      size: iconSize,
      fixedWidth: true,
      icon: icon
    });
  }
  if (hideText) {
    modifiers.push("button_text-hidden");
  }
  if (to || onClick) {
    return React.createElement("a", {
      onClick: onClick,
      className: "button button_size_".concat(size, " ").concat(modifiers.join(" "), " ").concat(className || ""),
      href: to
    }, children || (hideText ? null : text), faIcon);
  }
  return null;
};
var UrlLink = function (_a) {
  var url = _a.url,
    _b = _a.children,
    children = _b === void 0 ? undefined : _b;
  if (url) {
    return React.createElement("a", {
      href: url
    }, children);
  }
  return React.createElement(React.Fragment, null, children);
};
var Card = function (_a) {
  var Image = _a.Image,
    header = _a.header,
    body = _a.body,
    _b = _a.url,
    url = _b === void 0 ? undefined : _b,
    _c = _a.cardType,
    cardType = _c === void 0 ? "article" : _c,
    _d = _a.categories,
    categories = _d === void 0 ? [] : _d,
    _e = _a.timeToRead,
    timeToRead = _e === void 0 ? undefined : _e,
    learnMoreToggle = _a.learnMoreToggle,
    _f = _a.learnMoreContent,
    learnMoreContent = _f === void 0 ? null : _f;
  var categoryLinks = categories.map(function (category) {
    return React.createElement("a", {
      key: category.url,
      href: category.url
    }, category.name);
  });
  return React.createElement("div", {
    className: "card card_".concat(cardType)
  }, Image && React.createElement("figure", {
    className: "card__photo"
  }, React.createElement(UrlLink, {
    url: url
  }, React.createElement(Image, null))), React.createElement("div", {
    className: "card__card-content-container"
  }, React.createElement("h3", {
    className: "card__header"
  }, React.createElement(UrlLink, {
    url: url
  }, header)), React.createElement("p", {
    className: "card__body",
    dangerouslySetInnerHTML: {
      __html: body
    }
  }), cardType === "article" && (categoryLinks.length > 0 || timeToRead) && React.createElement("section", {
    className: "card__readmore"
  }, React.createElement("p", {
    className: "card__links"
  }, categoryLinks), React.createElement("p", {
    className: "card__time-to-read"
  }, React.createElement(UrlLink, {
    url: url
  }, timeToRead, " minutes")))), learnMoreToggle ? learnMoreContent || React.createElement("a", {
    className: "card__learn-more"
  }, "Learn more") : null);
};
var DesktopDeviceTile = function (_a) {
  var Image = _a.Image;
  return React.createElement("div", {
    className: "desktop-device-wrapper"
  }, React.createElement("div", {
    className: "desktop-device__screen marvel-device macbook"
  }, React.createElement("div", {
    className: "top-bar"
  }), React.createElement("div", {
    className: "camera"
  }), React.createElement("div", {
    className: "screen"
  }, React.createElement(Image, {
    className: "desktop-device__student-screenshot"
  })), React.createElement("div", {
    className: "bottom-bar"
  })));
};
var DesktopProjectCard = function (_a) {
  var Image = _a.Image,
    projectLiveUrl = _a.projectLiveUrl,
    projectTitle = _a.projectTitle,
    studentName = _a.studentName,
    studentProfileUrl = _a.studentProfileUrl;
  var studentProfileImage;
  if (studentProfileUrl) {
    studentProfileImage = React.createElement("img", {
      src: studentProfileUrl
    });
  }
  return React.createElement("article", {
    className: "card card__desktop-tile"
  }, React.createElement("section", {
    className: "card__photo"
  }, React.createElement(DesktopDeviceTile, {
    Image: Image
  })), React.createElement("section", {
    className: "project-tile__student-info"
  }, studentProfileImage && React.createElement("figure", {
    className: "student-info__student-profile"
  }, studentProfileImage), React.createElement("div", {
    className: "student-info__title"
  }, React.createElement("a", {
    href: projectLiveUrl
  }, React.createElement("h4", {
    className: "card__header"
  }, projectTitle)), React.createElement("h6", {
    className: "card__body"
  }, studentName))));
};
var faBars = {
  prefix: 'fas',
  iconName: 'bars',
  icon: [448, 512, [], "f0c9", "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"]
};
var faMinusSquare = {
  prefix: 'fas',
  iconName: 'minus-square',
  icon: [448, 512, [], "f146", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"]
};
var faPlusSquare = {
  prefix: 'fas',
  iconName: 'plus-square',
  icon: [448, 512, [], "f0fe", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"]
};
var faStar = {
  prefix: 'fas',
  iconName: 'star',
  icon: [576, 512, [], "f005", "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"]
};
var faTimes = {
  prefix: 'fas',
  iconName: 'times',
  icon: [352, 512, [], "f00d", "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"]
};
var faUserGraduate = {
  prefix: 'fas',
  iconName: 'user-graduate',
  icon: [448, 512, [], "f501", "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"]
};
var MobileDeviceTile = function (_a) {
  var Image = _a.Image,
    altText = _a.altText;
  return React.createElement("div", {
    className: "mobile-device-wrapper "
  }, React.createElement("div", {
    className: "marvel-device iphone-x device-mobile__screen"
  }, React.createElement("div", {
    className: "notch"
  }, React.createElement("div", {
    className: "camera"
  }), React.createElement("div", {
    className: "speaker"
  })), React.createElement("div", {
    className: "top-bar"
  }), React.createElement("div", {
    className: "sleep"
  }), React.createElement("div", {
    className: "bottom-bar"
  }), React.createElement("div", {
    className: "volume"
  }), React.createElement("div", {
    className: "overflow"
  }, React.createElement("div", {
    className: "shadow shadow--tr"
  }), React.createElement("div", {
    className: "shadow shadow--tl"
  }), React.createElement("div", {
    className: "shadow shadow--br"
  }), React.createElement("div", {
    className: "shadow shadow--bl"
  })), React.createElement("div", {
    className: "inner-shadow"
  }), React.createElement("div", {
    className: "screen",
    style: {
      display: "grid"
    }
  }, React.createElement(Image, {
    altText: altText
  }))));
};
var MobileProjectCard = function (_a) {
  var Image = _a.Image,
    projectLiveUrl = _a.projectLiveUrl,
    projectTitle = _a.projectTitle,
    studentName = _a.studentName,
    studentProfileUrl = _a.studentProfileUrl;
  var studentProfileImage = React.createElement(FontAwesomeIcon, {
    icon: faUserGraduate
  });
  if (studentProfileUrl) {
    studentProfileImage = React.createElement("img", {
      src: studentProfileUrl
    });
  }
  return React.createElement("article", {
    className: "card card__mobile-tile"
  }, React.createElement("section", {
    className: "card__photo"
  }, React.createElement(MobileDeviceTile, {
    Image: Image
  })), React.createElement("section", {
    className: "project-tile__student-info"
  }, React.createElement("figure", {
    className: "student-info__student-profile"
  }, studentProfileImage), React.createElement("div", {
    className: "student-info__title"
  }, React.createElement("a", {
    href: projectLiveUrl
  }, React.createElement("h4", {
    className: "card__header"
  }, projectTitle)), React.createElement("h6", {
    className: "card__body"
  }, studentName))));
};
var CardList = function (_a) {
  var content = _a.content,
    _b = _a.cardType,
    cardType = _b === void 0 ? "article" : _b,
    numberOfColumns = _a.numberOfColumns,
    className = _a.className,
    _c = _a.learnMoreToggle,
    learnMoreToggle = _c === void 0 ? false : _c,
    _d = _a.learnMoreContent,
    learnMoreContent = _d === void 0 ? null : _d;
  var cardListSize = "card-list";
  if (numberOfColumns === 2) {
    cardListSize += "_medium";
  } else if (numberOfColumns === 3) {
    cardListSize += "_large";
  }
  var cardContentArray = content.map(function (card) {
    if (card.mobile === true) {
      return React.createElement(MobileProjectCard, {
        key: card.id,
        Image: card.Image,
        projectTitle: card.projectTitle,
        studentName: card.studentName,
        studentProfileUrl: card.studentProfileUrl
      });
    }
    if (card.mobile === false) {
      return React.createElement(DesktopProjectCard, {
        key: card.id,
        Image: card.Image,
        projectTitle: card.projectTitle,
        studentName: card.studentName,
        studentProfileUrl: card.studentProfileUrl
      });
    }
    return React.createElement(Card, {
      key: card.id,
      Image: card.Image,
      header: card.header,
      body: card.body,
      url: card.articleUrl,
      timeToRead: card.timeToRead,
      categories: card.categories,
      learnMoreToggle: learnMoreToggle,
      learnMoreContent: learnMoreContent
    });
  });
  return React.createElement("div", {
    className: "".concat([cardListSize, className, "card-list_".concat(cardType)].join(" "))
  }, cardContentArray);
}; /*! *****************************************************************************
   Copyright (c) Microsoft Corporation.
   Permission to use, copy, modify, and/or distribute this software for any
   purpose with or without fee is hereby granted.
   THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
   REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
   AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
   INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
   LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
   OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
   PERFORMANCE OF THIS SOFTWARE.
   ***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var AccentCircle = function (_a) {
  var _b = _a.width,
    width = _b === void 0 ? 8 : _b,
    _c = _a.color,
    color = _c === void 0 ? "white" : _c,
    props = __rest(_a, ["width", "color"]);
  return React.createElement("div", _assign({}, props, {
    className: "accent-circle accent-circle__".concat(color, " w-").concat(width, " h-").concat(width, " ").concat(props.className)
  }));
};
var colors = {
  primaryBrand: {
    applications: ["CTAs", "Focused/Active states"],
    hex: "#6930C3",
    colorName: "Purple"
  },
  secondaryBrand: {
    applications: ["Background colors", "Accents", "Valid fields", "Success Messages"],
    hex: "#2CCBC0",
    colorName: "Teal"
  },
  tertiaryBrand: {
    applications: ["Accents", "Illustrations", "Warnings", "Alerts"],
    hex: "#FFC759",
    colorName: "Gold"
  },
  warning: {
    applications: ["Errors", "Alerts"],
    hex: "#C33042",
    colorName: "Red"
  },
  text: {
    applications: ["Shadows", "Headings", "Text", "Modal Overlays"],
    hex: "#1A1A1A",
    colorName: "Black"
  },
  secondaryText: {
    applications: ["Helper Text"],
    hex: "#4f4959",
    colorName: "Gray Slate"
  },
  tertiaryText: {
    applications: ["De-Emphasized Text"],
    hex: "#ACA9AF",
    colorName: "Gray Light Slate"
  },
  accent: {
    applications: ["Accent Color", "Hairlines", "Subtle Backgrounds"],
    hex: "#F3F1F4",
    colorName: "Gray Dorian"
  },
  light: {
    applications: ["Light mode backgrounds", "Light mode dialogs/alerts"],
    hex: "#F8F8F8",
    colorName: "Gray Cloud"
  },
  photoOverlay: {
    applications: ["Overlays - Use exclusively for this purpose"],
    hex: "#522B29",
    colorName: "Brown"
  },
  white: {
    applications: ["Primary button text"],
    hex: "#fff",
    colorName: "White"
  }
};
var CreativeContent = function (_a) {
  var children = _a.children;
  return React.createElement("div", {
    className: "creative-content__container"
  }, children);
};
var css_248z$5 = "svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -.125em;\n}\n\n.svg-inline--fa.fa-lg {\n  vertical-align: -.225em;\n}\n\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n\n.svg-inline--fa.fa-pull-left {\n  margin-right: .3em;\n  width: auto;\n}\n\n.svg-inline--fa.fa-pull-right {\n  margin-left: .3em;\n  width: auto;\n}\n\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -.125em;\n  width: 1em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n  transform-origin: center center;\n}\n\n.fa-layers-text, .fa-layers-counter {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: .25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n  transform: scale(0.25);\n  -webkit-transform-origin: top right;\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n  transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n  transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n  transform: scale(0.25);\n  -webkit-transform-origin: top right;\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n  transform: scale(0.25);\n  -webkit-transform-origin: top left;\n  transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -.0667em;\n}\n\n.fa-xs {\n  font-size: .75em;\n}\n\n.fa-sm {\n  font-size: .875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: .1em;\n  padding: .2em .25em .15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: .3em;\n}\n\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: .3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n  animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n  animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n  transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n  filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}\n";
styleInject(css_248z$5);
var Icon = function (_a) {
  var icon = _a.icon,
    _b = _a.fixedWidth,
    fixedWidth = _b === void 0 ? false : _b,
    className = _a.className;
  return React.createElement(FontAwesomeIcon, {
    icon: icon,
    className: "".concat(className),
    fixedWidth: fixedWidth,
    width: "18"
  });
};
var css_248z$4 = ".faq {\n  padding-bottom: 1rem\n}\n\n@media (min-width: 768px) {\n  .faq {\n    width: 75%\n  }\n}\n\n.faq .faq__content {\n  display: flex;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.faq .faq__title-container {\n  flex-grow: 1;\n  font-family: Ubuntu, sans-serif;\n  font-size: 1.125rem;\n  line-height: 1.3125rem;\n  font-weight: 700;\n}\n\n.faq .faq__icon-container {\n  margin-left: 1rem;\n  flex: none;\n  place-content: end;\n}\n\n.faq .faq__description {\n  grid-column: span 4 / span 4;\n  font-family: Open Sans, sans-serif\n}\n\n.faq .faq__description p {\n  margin-bottom: 1rem;\n}\n\n.faq .faq__description a {\n  --tw-text-opacity: 1;\n  color: rgba(105, 48, 195, var(--tw-text-opacity));\n  text-decoration: none;\n}\n\n.faq .faq__description a:hover {\n  text-decoration: underline\n}\n";
styleInject(css_248z$4);
var Faq = function (_a) {
  var title = _a.title,
    description = _a.description,
    selected = _a.selected,
    handleClick = _a.handleClick;
  var button;
  var questionClass;
  if (selected) {
    questionClass = "block";
    button = React.createElement(Icon, {
      icon: faMinusSquare,
      onClick: handleClick
    });
  } else {
    questionClass = "hidden";
    button = React.createElement(Icon, {
      icon: faPlusSquare,
      onClick: handleClick
    });
  }
  return React.createElement("div", {
    className: "faq",
    onClick: handleClick
  }, React.createElement("div", {
    className: "faq__content"
  }, React.createElement("div", {
    className: "faq__title-container"
  }, title), React.createElement("div", {
    className: "faq__icon-container"
  }, React.createElement("button", {
    type: "button"
  }, button))), React.createElement("p", {
    className: "faq__description ".concat(questionClass)
  }, description));
};
var FaqList = function (_a) {
  var questions = _a.questions;
  var _b = useState([-1]),
    selectedQuestion = _b[0],
    setSelectedQuestion = _b[1];
  var toggleQuestionSelect = function (id) {
    if (selectedQuestion.includes(id)) {
      setSelectedQuestion(selectedQuestion.filter(function (questionId) {
        return questionId !== id;
      }));
    } else {
      setSelectedQuestion(__spreadArray(__spreadArray([], selectedQuestion, true), [id], false));
    }
  };
  var questionListItems = questions.map(function (question) {
    var selected = false;
    if (selectedQuestion.includes(question.id)) {
      selected = true;
    }
    var handleClick = function () {
      toggleQuestionSelect(question.id);
    };
    return React.createElement(Faq, {
      key: question.id,
      title: question.title,
      description: question.description,
      selected: selected,
      handleClick: handleClick
    });
  });
  return React.createElement("div", {
    className: "faq-list"
  }, React.createElement("div", {
    className: "faq-list__container"
  }, questionListItems));
};
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  it = o[Symbol.iterator]();
  return it.next.bind(it);
}
function match(value, lookup) {
  if (value in lookup) {
    var returnValue = lookup[value];
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    return typeof returnValue === 'function' ? returnValue.apply(void 0, args) : returnValue;
  }
  var error = new Error("Tried to handle \"" + value + "\" but there is no handler defined. Only defined handlers are: " + Object.keys(lookup).map(function (key) {
    return "\"" + key + "\"";
  }).join(', ') + ".");
  if (Error.captureStackTrace) Error.captureStackTrace(error, match);
  throw error;
}
var Features;
(function (Features) {
  /** No features at all */
  Features[Features["None"] = 0] = "None";
  /**
   * When used, this will allow us to use one of the render strategies.
   *
   * **The render strategies are:**
   *    - **Unmount**   _(Will unmount the component.)_
   *    - **Hidden**    _(Will hide the component using the [hidden] attribute.)_
   */

  Features[Features["RenderStrategy"] = 1] = "RenderStrategy";
  /**
   * When used, this will allow the user of our component to be in control. This can be used when
   * you want to transition based on some state.
   */

  Features[Features["Static"] = 2] = "Static";
})(Features || (Features = {}));
var RenderStrategy;
(function (RenderStrategy) {
  RenderStrategy[RenderStrategy["Unmount"] = 0] = "Unmount";
  RenderStrategy[RenderStrategy["Hidden"] = 1] = "Hidden";
})(RenderStrategy || (RenderStrategy = {}));
function render(_ref) {
  var props = _ref.props,
    slot = _ref.slot,
    defaultTag = _ref.defaultTag,
    features = _ref.features,
    _ref$visible = _ref.visible,
    visible = _ref$visible === void 0 ? true : _ref$visible,
    name = _ref.name; // Visible always render

  if (visible) return _render(props, slot, defaultTag, name);
  var featureFlags = features != null ? features : Features.None;
  if (featureFlags & Features.Static) {
    var _props$static = props["static"],
      isStatic = _props$static === void 0 ? false : _props$static,
      rest = _objectWithoutPropertiesLoose(props, ["static"]); // When the `static` prop is passed as `true`, then the user is in control, thus we don't care about anything else

    if (isStatic) return _render(rest, slot, defaultTag, name);
  }
  if (featureFlags & Features.RenderStrategy) {
    var _match;
    var _props$unmount = props.unmount,
      unmount = _props$unmount === void 0 ? true : _props$unmount,
      _rest = _objectWithoutPropertiesLoose(props, ["unmount"]);
    var strategy = unmount ? RenderStrategy.Unmount : RenderStrategy.Hidden;
    return match(strategy, (_match = {}, _match[RenderStrategy.Unmount] = function () {
      return null;
    }, _match[RenderStrategy.Hidden] = function () {
      return _render(_extends({}, _rest, {
        hidden: true,
        style: {
          display: 'none'
        }
      }), slot, defaultTag, name);
    }, _match));
  } // No features enabled, just render

  return _render(props, slot, defaultTag, name);
}
function _render(props, slot, tag, name) {
  var _ref2;
  if (slot === void 0) {
    slot = {};
  }
  var _omit = omit(props, ['unmount', 'static']),
    _omit$as = _omit.as,
    Component = _omit$as === void 0 ? tag : _omit$as,
    children = _omit.children,
    _omit$refName = _omit.refName,
    refName = _omit$refName === void 0 ? 'ref' : _omit$refName,
    passThroughProps = _objectWithoutPropertiesLoose(_omit, ["as", "children", "refName"]); // This allows us to use `<HeadlessUIComponent as={MyComponent} refName="innerRef" />`

  var refRelatedProps = props.ref !== undefined ? (_ref2 = {}, _ref2[refName] = props.ref, _ref2) : {};
  var resolvedChildren = typeof children === 'function' ? children(slot) : children; // Allow for className to be a function with the slot as the contents

  if (passThroughProps.className && typeof passThroughProps.className === 'function') {
    passThroughProps.className = passThroughProps.className(slot);
  }
  if (Component === Fragment) {
    if (Object.keys(passThroughProps).length > 0) {
      if (! /*#__PURE__*/isValidElement(resolvedChildren) || Array.isArray(resolvedChildren) && resolvedChildren.length > 1) {
        throw new Error(['Passing props on "Fragment"!', '', "The current component <" + name + " /> is rendering a \"Fragment\".", "However we need to passthrough the following props:", Object.keys(passThroughProps).map(function (line) {
          return "  - " + line;
        }).join('\n'), '', 'You can apply a few solutions:', ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', 'Render a single element as the child so that we can forward the props onto that element.'].map(function (line) {
          return "  - " + line;
        }).join('\n')].join('\n'));
      }
      return /*#__PURE__*/cloneElement(resolvedChildren, Object.assign({},
      // Filter out undefined values so that they don't override the existing values
      mergeEventFunctions(compact(omit(passThroughProps, ['ref'])), resolvedChildren.props, ['onClick']), refRelatedProps));
    }
  }
  return /*#__PURE__*/createElement(Component, Object.assign({}, omit(passThroughProps, ['ref']), Component !== Fragment && refRelatedProps), resolvedChildren);
}
/**
 * We can use this function for the following useCase:
 *
 * <Menu.Item> <button onClick={console.log} /> </Menu.Item>
 *
 * Our `Menu.Item` will have an internal `onClick`, if you passthrough an `onClick` to the actual
 * `Menu.Item` component we will call it correctly. However, when we have an `onClick` on the actual
 * first child, that one should _also_ be called (but before this implementation, it was just
 * overriding the `onClick`). But it is only when we *render* that we have access to the existing
 * props of this component.
 *
 * It's a bit hacky, and not that clean, but it is something internal and we have tests to rely on
 * so that we can refactor this later (if needed).
 */

function mergeEventFunctions(passThroughProps, existingProps, functionsToMerge) {
  var clone = Object.assign({}, passThroughProps);
  var _loop = function _loop() {
    var func = _step.value;
    if (passThroughProps[func] !== undefined && existingProps[func] !== undefined) {
      var _Object$assign;
      Object.assign(clone, (_Object$assign = {}, _Object$assign[func] = function (event) {
        // Props we control
        if (!event.defaultPrevented) passThroughProps[func](event); // Existing props on the component

        if (!event.defaultPrevented) existingProps[func](event);
      }, _Object$assign));
    }
  };
  for (var _iterator = _createForOfIteratorHelperLoose(functionsToMerge), _step; !(_step = _iterator()).done;) {
    _loop();
  }
  return clone;
}
/**
 * This is a hack, but basically we want to keep the full 'API' of the component, but we do want to
 * wrap it in a forwardRef so that we _can_ passthrough the ref
 */

function forwardRefWithAs(component) {
  var _component$displayNam;
  return Object.assign( /*#__PURE__*/forwardRef(component), {
    displayName: (_component$displayNam = component.displayName) != null ? _component$displayNam : component.name
  });
}
function compact(object) {
  var clone = Object.assign({}, object);
  for (var key in clone) {
    if (clone[key] === undefined) delete clone[key];
  }
  return clone;
}
function omit(object, keysToOmit) {
  if (keysToOmit === void 0) {
    keysToOmit = [];
  }
  var clone = Object.assign({}, object);
  for (var _iterator2 = _createForOfIteratorHelperLoose(keysToOmit), _step2; !(_step2 = _iterator2()).done;) {
    var key = _step2.value;
    if (key in clone) delete clone[key];
  }
  return clone;
}
var useIsoMorphicEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
var state = {
  serverHandoffComplete: false
};
function useServerHandoffComplete() {
  var _useState = useState(state.serverHandoffComplete),
    serverHandoffComplete = _useState[0],
    setServerHandoffComplete = _useState[1];
  useEffect(function () {
    if (serverHandoffComplete === true) return;
    setServerHandoffComplete(true);
  }, [serverHandoffComplete]);
  useEffect(function () {
    if (state.serverHandoffComplete === false) state.serverHandoffComplete = true;
  }, []);
  return serverHandoffComplete;
}
function useSyncRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var cache = useRef(refs);
  useEffect(function () {
    cache.current = refs;
  }, [refs]);
  return useCallback(function (value) {
    for (var _iterator = _createForOfIteratorHelperLoose(cache.current), _step; !(_step = _iterator()).done;) {
      var ref = _step.value;
      if (ref == null) continue;
      if (typeof ref === 'function') ref(value);else ref.current = value;
    }
  }, [cache]);
} // TODO: This must already exist somewhere, right? 🤔
// Ref: https://www.w3.org/TR/uievents-key/#named-key-attribute-values
var Keys;
(function (Keys) {
  Keys["Space"] = " ";
  Keys["Enter"] = "Enter";
  Keys["Escape"] = "Escape";
  Keys["Backspace"] = "Backspace";
  Keys["ArrowLeft"] = "ArrowLeft";
  Keys["ArrowUp"] = "ArrowUp";
  Keys["ArrowRight"] = "ArrowRight";
  Keys["ArrowDown"] = "ArrowDown";
  Keys["Home"] = "Home";
  Keys["End"] = "End";
  Keys["PageUp"] = "PageUp";
  Keys["PageDown"] = "PageDown";
  Keys["Tab"] = "Tab";
})(Keys || (Keys = {})); // See: https://github.com/facebook/react/issues/7711
// See: https://github.com/facebook/react/pull/20612
// See: https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#concept-fe-disabled (2.)
function isDisabledReactIssue7711(element) {
  var _ref, _parent;
  var parent = element.parentElement;
  var legend = null;
  while (parent && !(parent instanceof HTMLFieldSetElement)) {
    if (parent instanceof HTMLLegendElement) legend = parent;
    parent = parent.parentElement;
  }
  var isParentDisabled = (_ref = ((_parent = parent) == null ? void 0 : _parent.getAttribute('disabled')) === '') != null ? _ref : false;
  if (isParentDisabled && isFirstLegend(legend)) return false;
  return isParentDisabled;
}
function isFirstLegend(element) {
  if (!element) return false;
  var previous = element.previousElementSibling;
  while (previous !== null) {
    if (previous instanceof HTMLLegendElement) return false;
    previous = previous.previousElementSibling;
  }
  return true;
} // uses.
//
// Credits: https://github.com/reach/reach-ui/blob/develop/packages/auto-id/src/index.tsx

var id = 0;
function generateId() {
  return ++id;
}
function useId() {
  var ready = useServerHandoffComplete();
  var _useState = useState(ready ? generateId : null),
    id = _useState[0],
    setId = _useState[1];
  useIsoMorphicEffect(function () {
    if (id === null) setId(generateId());
  }, [id]);
  return id != null ? '' + id : undefined;
}
var Context = /*#__PURE__*/createContext(null);
Context.displayName = 'OpenClosedContext';
var State;
(function (State) {
  State[State["Open"] = 0] = "Open";
  State[State["Closed"] = 1] = "Closed";
})(State || (State = {}));
function useOpenClosed() {
  return useContext(Context);
}
function OpenClosedProvider(_ref) {
  var value = _ref.value,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: value
  }, children);
}
function resolveType(props) {
  var _props$as;
  if (props.type) return props.type;
  var tag = (_props$as = props.as) != null ? _props$as : 'button';
  if (typeof tag === 'string' && tag.toLowerCase() === 'button') return 'button';
  return undefined;
}
function useResolveButtonType(props, ref) {
  var _useState = useState(function () {
      return resolveType(props);
    }),
    type = _useState[0],
    setType = _useState[1];
  useIsoMorphicEffect(function () {
    setType(resolveType(props));
  }, [props.type, props.as]);
  useIsoMorphicEffect(function () {
    if (type) return;
    if (!ref.current) return;
    if (ref.current instanceof HTMLButtonElement && !ref.current.hasAttribute('type')) {
      setType('button');
    }
  }, [type, ref]);
  return type;
}
var _reducers;
var DisclosureStates;
(function (DisclosureStates) {
  DisclosureStates[DisclosureStates["Open"] = 0] = "Open";
  DisclosureStates[DisclosureStates["Closed"] = 1] = "Closed";
})(DisclosureStates || (DisclosureStates = {}));
var ActionTypes;
(function (ActionTypes) {
  ActionTypes[ActionTypes["ToggleDisclosure"] = 0] = "ToggleDisclosure";
  ActionTypes[ActionTypes["CloseDisclosure"] = 1] = "CloseDisclosure";
  ActionTypes[ActionTypes["SetButtonId"] = 2] = "SetButtonId";
  ActionTypes[ActionTypes["SetPanelId"] = 3] = "SetPanelId";
  ActionTypes[ActionTypes["LinkPanel"] = 4] = "LinkPanel";
  ActionTypes[ActionTypes["UnlinkPanel"] = 5] = "UnlinkPanel";
})(ActionTypes || (ActionTypes = {}));
var reducers = (_reducers = {}, _reducers[ActionTypes.ToggleDisclosure] = function (state) {
  var _match;
  return _extends({}, state, {
    disclosureState: match(state.disclosureState, (_match = {}, _match[DisclosureStates.Open] = DisclosureStates.Closed, _match[DisclosureStates.Closed] = DisclosureStates.Open, _match))
  });
}, _reducers[ActionTypes.CloseDisclosure] = function (state) {
  if (state.disclosureState === DisclosureStates.Closed) return state;
  return _extends({}, state, {
    disclosureState: DisclosureStates.Closed
  });
}, _reducers[ActionTypes.LinkPanel] = function (state) {
  if (state.linkedPanel === true) return state;
  return _extends({}, state, {
    linkedPanel: true
  });
}, _reducers[ActionTypes.UnlinkPanel] = function (state) {
  if (state.linkedPanel === false) return state;
  return _extends({}, state, {
    linkedPanel: false
  });
}, _reducers[ActionTypes.SetButtonId] = function (state, action) {
  if (state.buttonId === action.buttonId) return state;
  return _extends({}, state, {
    buttonId: action.buttonId
  });
}, _reducers[ActionTypes.SetPanelId] = function (state, action) {
  if (state.panelId === action.panelId) return state;
  return _extends({}, state, {
    panelId: action.panelId
  });
}, _reducers);
var DisclosureContext = /*#__PURE__*/createContext(null);
DisclosureContext.displayName = 'DisclosureContext';
function useDisclosureContext(component) {
  var context = useContext(DisclosureContext);
  if (context === null) {
    var err = new Error("<" + component + " /> is missing a parent <" + Disclosure.name + " /> component.");
    if (Error.captureStackTrace) Error.captureStackTrace(err, useDisclosureContext);
    throw err;
  }
  return context;
}
var DisclosureAPIContext = /*#__PURE__*/createContext(null);
DisclosureAPIContext.displayName = 'DisclosureAPIContext';
function useDisclosureAPIContext(component) {
  var context = useContext(DisclosureAPIContext);
  if (context === null) {
    var err = new Error("<" + component + " /> is missing a parent <" + Disclosure.name + " /> component.");
    if (Error.captureStackTrace) Error.captureStackTrace(err, useDisclosureAPIContext);
    throw err;
  }
  return context;
}
var DisclosurePanelContext = /*#__PURE__*/createContext(null);
DisclosurePanelContext.displayName = 'DisclosurePanelContext';
function useDisclosurePanelContext() {
  return useContext(DisclosurePanelContext);
}
function stateReducer(state, action) {
  return match(action.type, reducers, state, action);
} // ---

var DEFAULT_DISCLOSURE_TAG = Fragment;
function Disclosure(props) {
  var _match2;
  var _props$defaultOpen = props.defaultOpen,
    defaultOpen = _props$defaultOpen === void 0 ? false : _props$defaultOpen,
    passthroughProps = _objectWithoutPropertiesLoose(props, ["defaultOpen"]);
  var buttonId = "headlessui-disclosure-button-" + useId();
  var panelId = "headlessui-disclosure-panel-" + useId();
  var reducerBag = useReducer(stateReducer, {
    disclosureState: defaultOpen ? DisclosureStates.Open : DisclosureStates.Closed,
    linkedPanel: false,
    buttonId: buttonId,
    panelId: panelId
  });
  var disclosureState = reducerBag[0].disclosureState,
    dispatch = reducerBag[1];
  useEffect(function () {
    return dispatch({
      type: ActionTypes.SetButtonId,
      buttonId: buttonId
    });
  }, [buttonId, dispatch]);
  useEffect(function () {
    return dispatch({
      type: ActionTypes.SetPanelId,
      panelId: panelId
    });
  }, [panelId, dispatch]);
  var close = useCallback(function (focusableElement) {
    dispatch({
      type: ActionTypes.CloseDisclosure
    });
    var restoreElement = function () {
      if (!focusableElement) return document.getElementById(buttonId);
      if (focusableElement instanceof HTMLElement) return focusableElement;
      if (focusableElement.current instanceof HTMLElement) return focusableElement.current;
      return document.getElementById(buttonId);
    }();
    restoreElement == null ? void 0 : restoreElement.focus();
  }, [dispatch, buttonId]);
  var api = useMemo(function () {
    return {
      close: close
    };
  }, [close]);
  var slot = useMemo(function () {
    return {
      open: disclosureState === DisclosureStates.Open,
      close: close
    };
  }, [disclosureState, close]);
  return /*#__PURE__*/React.createElement(DisclosureContext.Provider, {
    value: reducerBag
  }, /*#__PURE__*/React.createElement(DisclosureAPIContext.Provider, {
    value: api
  }, /*#__PURE__*/React.createElement(OpenClosedProvider, {
    value: match(disclosureState, (_match2 = {}, _match2[DisclosureStates.Open] = State.Open, _match2[DisclosureStates.Closed] = State.Closed, _match2))
  }, render({
    props: passthroughProps,
    slot: slot,
    defaultTag: DEFAULT_DISCLOSURE_TAG,
    name: 'Disclosure'
  }))));
} // ---

var DEFAULT_BUTTON_TAG = 'button';
var Button = /*#__PURE__*/forwardRefWithAs(function Button(props, ref) {
  var _useDisclosureContext = useDisclosureContext([Disclosure.name, Button.name].join('.')),
    state = _useDisclosureContext[0],
    dispatch = _useDisclosureContext[1];
  var internalButtonRef = useRef(null);
  var buttonRef = useSyncRefs(internalButtonRef, ref);
  var panelContext = useDisclosurePanelContext();
  var isWithinPanel = panelContext === null ? false : panelContext === state.panelId;
  var handleKeyDown = useCallback(function (event) {
    var _document$getElementB;
    if (isWithinPanel) {
      if (state.disclosureState === DisclosureStates.Closed) return;
      switch (event.key) {
        case Keys.Space:
        case Keys.Enter:
          event.preventDefault();
          event.stopPropagation();
          dispatch({
            type: ActionTypes.ToggleDisclosure
          });
          (_document$getElementB = document.getElementById(state.buttonId)) == null ? void 0 : _document$getElementB.focus();
          break;
      }
    } else {
      switch (event.key) {
        case Keys.Space:
        case Keys.Enter:
          event.preventDefault();
          event.stopPropagation();
          dispatch({
            type: ActionTypes.ToggleDisclosure
          });
          break;
      }
    }
  }, [dispatch, isWithinPanel, state.disclosureState]);
  var handleKeyUp = useCallback(function (event) {
    switch (event.key) {
      case Keys.Space:
        // Required for firefox, event.preventDefault() in handleKeyDown for
        // the Space key doesn't cancel the handleKeyUp, which in turn
        // triggers a *click*.
        event.preventDefault();
        break;
    }
  }, []);
  var handleClick = useCallback(function (event) {
    if (isDisabledReactIssue7711(event.currentTarget)) return;
    if (props.disabled) return;
    if (isWithinPanel) {
      var _document$getElementB2;
      dispatch({
        type: ActionTypes.ToggleDisclosure
      });
      (_document$getElementB2 = document.getElementById(state.buttonId)) == null ? void 0 : _document$getElementB2.focus();
    } else {
      dispatch({
        type: ActionTypes.ToggleDisclosure
      });
    }
  }, [dispatch, props.disabled, state.buttonId, isWithinPanel]);
  var slot = useMemo(function () {
    return {
      open: state.disclosureState === DisclosureStates.Open
    };
  }, [state]);
  var type = useResolveButtonType(props, internalButtonRef);
  var passthroughProps = props;
  var propsWeControl = isWithinPanel ? {
    ref: buttonRef,
    type: type,
    onKeyDown: handleKeyDown,
    onClick: handleClick
  } : {
    ref: buttonRef,
    id: state.buttonId,
    type: type,
    'aria-expanded': props.disabled ? undefined : state.disclosureState === DisclosureStates.Open,
    'aria-controls': state.linkedPanel ? state.panelId : undefined,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onClick: handleClick
  };
  return render({
    props: _extends({}, passthroughProps, propsWeControl),
    slot: slot,
    defaultTag: DEFAULT_BUTTON_TAG,
    name: 'Disclosure.Button'
  });
}); // ---

var DEFAULT_PANEL_TAG = 'div';
var PanelRenderFeatures = Features.RenderStrategy | Features.Static;
var Panel = /*#__PURE__*/forwardRefWithAs(function Panel(props, ref) {
  var _useDisclosureContext2 = useDisclosureContext([Disclosure.name, Panel.name].join('.')),
    state = _useDisclosureContext2[0],
    dispatch = _useDisclosureContext2[1];
  var _useDisclosureAPICont = useDisclosureAPIContext([Disclosure.name, Panel.name].join('.')),
    close = _useDisclosureAPICont.close;
  var panelRef = useSyncRefs(ref, function () {
    if (state.linkedPanel) return;
    dispatch({
      type: ActionTypes.LinkPanel
    });
  });
  var usesOpenClosedState = useOpenClosed();
  var visible = function () {
    if (usesOpenClosedState !== null) {
      return usesOpenClosedState === State.Open;
    }
    return state.disclosureState === DisclosureStates.Open;
  }(); // Unlink on "unmount" myself

  useEffect(function () {
    return function () {
      return dispatch({
        type: ActionTypes.UnlinkPanel
      });
    };
  }, [dispatch]); // Unlink on "unmount" children

  useEffect(function () {
    var _props$unmount;
    if (state.disclosureState === DisclosureStates.Closed && ((_props$unmount = props.unmount) != null ? _props$unmount : true)) {
      dispatch({
        type: ActionTypes.UnlinkPanel
      });
    }
  }, [state.disclosureState, props.unmount, dispatch]);
  var slot = useMemo(function () {
    return {
      open: state.disclosureState === DisclosureStates.Open,
      close: close
    };
  }, [state, close]);
  var propsWeControl = {
    ref: panelRef,
    id: state.panelId
  };
  var passthroughProps = props;
  return /*#__PURE__*/React.createElement(DisclosurePanelContext.Provider, {
    value: state.panelId
  }, render({
    props: _extends({}, passthroughProps, propsWeControl),
    slot: slot,
    defaultTag: DEFAULT_PANEL_TAG,
    features: PanelRenderFeatures,
    visible: visible,
    name: 'Disclosure.Panel'
  }));
}); // ---

Disclosure.Button = Button;
Disclosure.Panel = Panel;
var TopBar = function (_a) {
  var logo = _a.logo,
    children = _a.children;
  return React.createElement("div", {
    className: "top-bar-navigation-container"
  }, React.createElement(Disclosure, {
    as: "nav",
    className: "top-bar-navigation"
  }, function (_a) {
    var open = _a.open;
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: "flex-initial flex items-center justify-center sm:items-stretch sm:justify-start"
    }, React.createElement("div", {
      className: "flex-shrink-0 flex items-center top-bar__logo"
    }, logo)), React.createElement("div", {
      className: "top-bar-navigation__menu-toggle"
    }, React.createElement(Disclosure.Button, {
      className: "top-bar-navigation__menu-toggle-button",
      "aria-label": "Navigation Menu"
    }, React.createElement("span", {
      className: "sr-only"
    }, "Open main menu"), open ? React.createElement(Icon, {
      icon: faTimes,
      className: "block h-6 w-6",
      "aria-hidden": "true"
    }) : React.createElement(Icon, {
      icon: faBars,
      className: "block h-6 w-6",
      "aria-hidden": "true"
    }))), React.createElement("div", {
      className: "".concat(open ? "top-bar-navigation__menu-list__open" : "top-bar-navigation__menu-list__closed")
    }, children));
  }));
};
var css_248z$3 = ".horizontal-profile-list__title {\n  display: grid;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n  padding: 1rem;\n}\n\n@media (min-width: 1024px) {\n  .horizontal-profile-list__title {\n    padding: 5rem;\n    text-align: left;\n  }\n}\n\n.horizontal-profile-list__container {\n  display: grid;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n@media (min-width: 1024px) {\n  .horizontal-profile-list__container {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    place-items: center;\n    justify-content: center;\n  }\n}\n\n.horizontal-profile {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n  text-align: center\n}\n\n@media (min-width: 1024px) {\n  .horizontal-profile {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    text-align: left;\n  }\n}\n\n.horizontal-profile .horizontal-profile__image {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n  display: inline-block;\n  border-radius: 9999px;\n  width: 13rem\n}\n\n@media (min-width: 1024px) {\n  .horizontal-profile .horizontal-profile__image {\n    grid-column: span 1 / span 1;\n    grid-column-start: 1;\n    width: 18rem;\n  }\n}\n\n.horizontal-profile .horizontal-profile__image img {\n  border-radius: 9999px;\n}\n\n@media (min-width: 1024px) {\n  .horizontal-profile .horizontal-profile__content {\n    grid-column: span 2 / span 2;\n    grid-column-start: 2;\n    padding: 2.5rem;\n    padding-top: 4rem;\n  }\n}\n\n.horizontal-profile .horizontal-profile__name {\n  margin-bottom: 0.5rem;\n  font-family: Ubuntu, sans-serif;\n  font-size: 1.5rem;\n  line-height: 1.75rem;\n  font-weight: 700;\n}\n\n@media (min-width: 1024px) {\n  .horizontal-profile .horizontal-profile__name {\n    margin-bottom: 0.25rem;\n    font-size: 1.5rem;\n    line-height: 1.75rem;\n  }\n}\n\n.horizontal-profile .horizontal-profile__current-title {\n  margin-bottom: 1rem;\n  font-size: .875rem;\n  line-height: 1.125rem;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n  letter-spacing: 0.05em;\n}\n\n@media (min-width: 1024px) {\n  .horizontal-profile .horizontal-profile__current-title {\n    margin-bottom: 0.5rem;\n    font-weight: 400;\n  }\n}\n\n.horizontal-profile .horizontal-profile__description {\n  margin-bottom: 0.5rem;\n  font-size: .875rem;\n  line-height: 1.125rem;\n}\n\n@media (min-width: 1024px) {\n  .horizontal-profile .horizontal-profile__description {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .horizontal-profile .horizontal-profile__description {\n    margin-bottom: 0px;\n    font-family: Open Sans, sans-serif;\n    font-size: .875rem;\n    line-height: 1.125rem;\n    text-transform: none;\n  }\n}\n";
styleInject(css_248z$3);
var HorizontalProfile = function (_a) {
  var name = _a.name,
    currentTitle = _a.currentTitle,
    formerTitle = _a.formerTitle,
    Image = _a.Image,
    altText = _a.altText,
    description = _a.description;
  return React.createElement("div", {
    className: "horizontal-profile"
  }, React.createElement(Image, {
    className: "horizontal-profile__image",
    alt: altText
  }), React.createElement("div", {
    className: "horizontal-profile__content"
  }, React.createElement("h5", {
    className: "horizontal-profile__name"
  }, name), React.createElement("h6", {
    className: "horizontal-profile__current-title"
  }, currentTitle), React.createElement("p", {
    className: "horizontal-profile__description"
  }, formerTitle && "Former ".concat(formerTitle, ","), " ", description)));
}; /*!
   * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
   * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
   */
var faFacebookF = {
  prefix: 'fab',
  iconName: 'facebook-f',
  icon: [320, 512, [], "f39e", "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"]
};
var faGithub = {
  prefix: 'fab',
  iconName: 'github',
  icon: [496, 512, [], "f09b", "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"]
};
var faLinkedin = {
  prefix: 'fab',
  iconName: 'linkedin',
  icon: [448, 512, [], "f08c", "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"]
};
var faTwitter = {
  prefix: 'fab',
  iconName: 'twitter',
  icon: [512, 512, [], "f099", "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"]
};
var faYoutube = {
  prefix: 'fab',
  iconName: 'youtube',
  icon: [576, 512, [], "f167", "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"]
};
var css_248z$2 = ".profile-list {\n  display: grid;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n@media (min-width: 1024px) {\n  .profile-list {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    place-items: center;\n    justify-content: center;\n    gap: 1rem;\n  }\n}\n\n.profile {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  text-align: center\n}\n\n.profile .profile__image {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n  display: inline-block;\n  border-radius: 9999px;\n  width: 13rem\n}\n\n@media (min-width: 1024px) {\n  .profile .profile__image {\n    width: 18rem;\n  }\n}\n\n.profile .profile__image img {\n  border-radius: 9999px;\n}\n\n.profile .profile__name {\n  margin-bottom: 2rem;\n  font-family: Ubuntu, sans-serif;\n  font-size: 1.5rem;\n  line-height: 1.75rem;\n  font-weight: 700;\n}\n\n@media (min-width: 1024px) {\n  .profile .profile__name {\n    margin-bottom: 0.25rem;\n    font-size: 2.25rem;\n    line-height: 2.4rem;\n  }\n}\n\n.profile .profile__label_current, .profile .profile__label_former {\n  margin-bottom: 0.25rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.profile .profile__label_current, .profile .profile__label_former {\n  letter-spacing: 0.05em;\n}\n\n@media (min-width: 1024px) {\n  .profile .profile__label_current, .profile .profile__label_former {\n    margin-bottom: 0.5rem;\n    font-weight: 400;\n  }\n}\n\n.profile .profile__current-title, .profile .profile__former-title {\n  margin-bottom: 0.5rem;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  font-size: 1.25rem;\n  line-height: 1.5rem;\n  text-transform: uppercase;\n}\n\n@media (min-width: 1024px) {\n  .profile .profile__current-title, .profile .profile__former-title {\n    margin-bottom: 0px;\n    font-family: Ubuntu, sans-serif;\n    font-size: 1.5rem;\n    line-height: 1.75rem;\n    font-weight: 400;\n    text-transform: none;\n  }\n}\n\n.profile .profile__current-title span, .profile .profile__former-title span {\n  width: 100%;\n}\n\n.profile__teamMember .profile__image {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n  display: inline-block;\n  border-radius: 9999px;\n  width: 13rem\n}\n\n@media (min-width: 1024px) {\n  .profile__teamMember .profile__image {\n    width: 18rem;\n  }\n}\n\n.profile__teamMember .profile__image img {\n  border-radius: 9999px;\n}\n\n.profile__teamMember .profile__name {\n  margin-bottom: 2rem;\n  font-family: Ubuntu, sans-serif;\n  font-size: 1.5rem;\n  line-height: 1.75rem;\n  font-weight: 700;\n}\n\n@media (min-width: 1024px) {\n  .profile__teamMember .profile__name {\n    margin-bottom: 0.5rem;\n    font-size: 1.5rem;\n    line-height: 1.75rem;\n  }\n}\n\n.profile__teamMember .profile__current-title {\n  margin-bottom: 0.5rem;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  font-size: 1.25rem;\n  line-height: 1.5rem;\n  text-transform: uppercase\n}\n\n.profile__teamMember .profile__current-title span {\n  width: 100%;\n}\n\n.profile__teamMember .profile__former-title {\n  display: none;\n}\n\n.profile__teamMember .profile__label_current, .profile__teamMember .profile__label_former {\n  display: none;\n}\n\n.profile__teamMember .profile__social {\n  display: inline-flex;\n  justify-content: center;\n  vertical-align: middle\n}\n\n.profile__teamMember .profile__social li {\n  margin: 0.5rem;\n  border-radius: 9999px;\n  --tw-bg-opacity: 1;\n  background-color: rgba(243, 241, 244, var(--tw-bg-opacity));\n  padding: 0.75rem;\n}\n";
styleInject(css_248z$2);
var Profile = function (_a) {
  var name = _a.name,
    _b = _a.profileType,
    profileType = _b === void 0 ? "launcher" : _b,
    currentTitle = _a.currentTitle,
    currentEmployer = _a.currentEmployer,
    formerTitle = _a.formerTitle,
    foundingMember = _a.foundingMember,
    socialUrls = _a.socialUrls,
    description = _a.description,
    Image = _a.Image;
  var whichProfileClass = "profile profile__".concat(profileType);
  var currentEmployerOrFoundingMember = React.createElement("h6", {
    className: "profile__current-title"
  }, currentTitle, profileType !== "teamMember" && React.createElement("span", null, "at ", currentEmployer));
  var socialList;
  if (socialUrls) {
    whichProfileClass = "profile profile_social";
    if (foundingMember) {
      currentEmployerOrFoundingMember = React.createElement("h6", {
        className: "profile__current-title"
      }, currentTitle, ", ", React.createElement("span", null, "FOUNDING TEAM MEMBER"));
    } else {
      currentEmployerOrFoundingMember = React.createElement("h6", {
        className: "profile__current-title"
      }, currentTitle);
    }
    var socialIcons = socialUrls.map(function (social) {
      var domain = new URL(social);
      var hostname = domain.hostname.replace("www.", "").replace(".com", "");
      // let iconHostname = hostname.replace(".com", "")
      var getIconByName = function (name) {
        return {
          twitter: faTwitter,
          facebook: faFacebookF,
          github: faGithub,
          youtube: faYoutube,
          linkedin: faLinkedin
        }[name];
      };
      return React.createElement("li", {
        key: hostname
      }, React.createElement("a", {
        href: social,
        "aria-label": "".concat(name, " on ").concat(hostname, " ")
      }, React.createElement(Icon, {
        icon: getIconByName(hostname),
        fixedWidth: true
      })));
    });
    socialList = React.createElement("ul", {
      className: "profile__social"
    }, socialIcons);
  }
  return React.createElement("div", {
    className: whichProfileClass
  }, Image && React.createElement(Image, {
    className: "profile__image"
  }), React.createElement("h5", {
    className: "profile__name"
  }, name), profileType !== "teamMember" && React.createElement("p", {
    className: "profile__label_current"
  }, "Current:"), currentEmployerOrFoundingMember, formerTitle && React.createElement(React.Fragment, null, React.createElement("p", {
    className: "profile__label_former"
  }, "Former:"), React.createElement("p", {
    className: "profile__former-title"
  }, formerTitle)), description && React.createElement("p", null, description), socialList);
};
var QuoteAuthor = function (_a) {
  var name = _a.name,
    company = _a.company;
  return React.createElement("figcaption", null, React.createElement("h6", {
    className: "quote__name"
  }, name), React.createElement("h5", {
    className: "quote__company"
  }, company));
};
var QuoteFeatureStudent = function (_a) {
  var name = _a.name,
    company = _a.company,
    studentImageUrl = _a.studentImageUrl;
  return React.createElement("figcaption", {
    className: "quote__student"
  }, React.createElement("img", {
    className: "student__profile-image",
    src: studentImageUrl
  }), React.createElement("div", {
    className: "student__text-info"
  }, React.createElement("h5", {
    className: "text-info__name"
  }, name), React.createElement("h6", {
    className: "text-info__company"
  }, company)));
};
var css_248z$1 = ".quote {\n  --tw-bg-opacity: 1;\n  background-color: rgba(44, 203, 192, var(--tw-bg-opacity));\n  padding-top: 2.5rem;\n  padding-right: 1.25rem;\n  padding-bottom: 2.5rem;\n  font-family: Open Sans, sans-serif\n}\n\n@media (min-width: 1024px) {\n  .quote > :not([hidden]) ~ :not([hidden]) {\n    --tw-divide-x-reverse: 0;\n    border-right-width: calc(2px * var(--tw-divide-x-reverse));\n    border-left-width: calc(2px * calc(1 - var(--tw-divide-x-reverse)))\n  }\n\n  .quote {\n    --tw-bg-opacity: 1;\n    background-color: rgba(255, 255, 255, var(--tw-bg-opacity))\n  }\n}\n\n@media (min-width: 1024px) {\n  .quote.quote_hero {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr))\n  }\n}\n\n.quote .quote__content {\n  grid-column: span 1 / span 1;\n  text-align: center;\n}\n\n.quote .quote__icon {\n  display: none;\n}\n\n@media (min-width: 1024px) {\n  .quote .quote__icon {\n    grid-column: span 1 / span 1;\n    display: block;\n    padding-right: 2.5rem;\n    text-align: right;\n    font-family: Libre Baskerville, serif;\n    font-size: 3.75rem;\n    line-height: 4rem;\n    font-weight: 400\n  }\n}\n\n.quote .quote__horizontal-line {\n  display: block;\n  padding-top: 0.75rem;\n}\n\n@media (min-width: 1024px) {\n  .quote .quote__horizontal-line {\n    display: none\n  }\n}\n\n.quote .quote__content {\n  grid-column: span 3 / span 3;\n  padding: 0.75rem;\n  text-align: center\n}\n\n.quote .quote__content .quote__text > :not([hidden]) ~ :not([hidden]) {\n  --tw-divide-x-reverse: 0;\n  border-right-width: calc(2px * var(--tw-divide-x-reverse));\n  border-left-width: calc(2px * calc(1 - var(--tw-divide-x-reverse)))\n}\n\n.quote .quote__content .quote__text {\n  padding-bottom: 1.25rem;\n  font-family: Open Sans, sans-serif\n}\n\n@media (min-width: 1024px) {\n  .quote .quote__content .quote__text {\n    text-align: left\n  }\n}\n\n.quote .quote__content .quote__name {\n  font-family: Ubuntu, sans-serif;\n  font-weight: 700;\n  text-transform: uppercase;\n  line-height: 1.375;\n}\n\n@media (min-width: 1024px) {\n  .quote .quote__content .quote__name {\n    text-align: left\n  }\n}\n\n.quote .quote__content .quote__company {\n  font-family: Open Sans, sans-serif;\n  text-transform: uppercase;\n}\n\n@media (min-width: 1024px) {\n  .quote .quote__content .quote__company {\n    text-align: left\n  }\n}\n\n.quote_banner > :not([hidden]) ~ :not([hidden]) {\n  --tw-divide-x-reverse: 0;\n  border-right-width: calc(0px * var(--tw-divide-x-reverse));\n  border-left-width: calc(0px * calc(1 - var(--tw-divide-x-reverse)))\n}\n\n.quote_banner {\n  --tw-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));\n  padding-top: 2.5rem;\n  padding-bottom: 2.5rem;\n  font-family: Open Sans, sans-serif\n}\n\n@media (min-width: 1024px) {\n  .quote_banner {\n    margin-left: 6rem;\n    margin-right: 6rem;\n    --tw-bg-opacity: 1;\n    background-color: rgba(255, 255, 255, var(--tw-bg-opacity))\n  }\n}\n\n.quote_banner .quote__icon {\n  display: none;\n}\n\n.quote_banner .quote__content {\n  text-align: center\n}\n\n@media (min-width: 1024px) {\n  .quote_banner .quote__content .quote__horizontal-line {\n    margin-left: 10rem;\n    margin-right: 10rem;\n    display: block\n  }\n}\n\n.quote_banner .quote__content .quote__text > :not([hidden]) ~ :not([hidden]) {\n  --tw-divide-x-reverse: 0;\n  border-right-width: calc(0px * var(--tw-divide-x-reverse));\n  border-left-width: calc(0px * calc(1 - var(--tw-divide-x-reverse)))\n}\n\n.quote_banner .quote__content .quote__text {\n  padding-bottom: 1.25rem;\n  text-align: center;\n  font-family: Open Sans, sans-serif;\n  font-size: 1.5rem;\n  line-height: 1.75rem;\n  font-weight: 700\n}\n\n.quote_banner .quote__content .quote__name {\n  padding-top: 0.75rem;\n  text-align: center;\n  font-family: Open Sans, sans-serif;\n  font-weight: 400;\n  text-transform: capitalize;\n}\n\n.quote_banner .quote__content .quote__company {\n  display: none;\n}\n\n.quote_feature-student {\n  margin-top: 4rem;\n  margin-bottom: 4rem;\n  display: grid;\n  grid-template-columns: repeat(12, minmax(0, 1fr))\n}\n\n.quote_feature-student > :not([hidden]) ~ :not([hidden]) {\n  --tw-divide-x-reverse: 0;\n  border-right-width: calc(0px * var(--tw-divide-x-reverse));\n  border-left-width: calc(0px * calc(1 - var(--tw-divide-x-reverse)))\n}\n\n.quote_feature-student {\n  --tw-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--tw-bg-opacity))\n}\n\n.quote_feature-student .quote__icon {\n  display: none;\n}\n\n.quote_feature-student .quote__content {\n  grid-column: span 12 / span 12\n}\n\n.quote_feature-student .quote__content .quote__horizontal-line {\n  display: none;\n}\n\n.quote_feature-student .quote__content .quote__text > :not([hidden]) ~ :not([hidden]) {\n  --tw-divide-x-reverse: 0;\n  border-right-width: calc(0px * var(--tw-divide-x-reverse));\n  border-left-width: calc(0px * calc(1 - var(--tw-divide-x-reverse)))\n}\n\n.quote_feature-student .quote__content .quote__text {\n  text-align: center;\n  font-size: 2rem;\n  line-height: 2.25rem;\n  font-weight: 700\n}\n\n.quote_feature-student .quote__content .quote__student {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  place-content: end;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem\n}\n\n.quote_feature-student .quote__content .quote__student .student__profile-image {\n  display: flex;\n  width: 4rem;\n  align-self: center;\n  justify-self: end;\n  border-radius: 9999px\n}\n\n.quote_feature-student .quote__content .quote__student .student__profile-image img {\n  border-radius: 9999px;\n}\n\n.quote_feature-student .quote__content .quote__student .student__text-info {\n  grid-column-start: 2;\n  margin-left: 1.25rem;\n  display: flex;\n  flex-wrap: wrap;\n  vertical-align: middle\n}\n\n.quote_feature-student .quote__content .quote__student .student__text-info .text-info__name {\n  width: 100%;\n  align-self: flex-end;\n  text-align: left;\n  font-family: Ubuntu, sans-serif;\n  font-weight: 700;\n}\n\n.quote_feature-student .quote__content .quote__student .student__text-info .text-info__company {\n  width: 100%;\n  text-align: left;\n  text-transform: uppercase;\n  line-height: 1;\n}\n";
styleInject(css_248z$1);
var Quote = function (_a) {
  var _b = _a.quoteType,
    quoteType = _b === void 0 ? "hero" : _b,
    quote = _a.quote,
    name = _a.name,
    company = _a.company,
    studentImageUrl = _a.studentImageUrl;
  var quoteTypeClass = "quote";
  var quoteAuthor = React.createElement(QuoteAuthor, {
    name: name,
    company: company
  });
  if (quoteType === "banner") {
    quoteTypeClass += " quote_banner";
  } else if (quoteType === "student") {
    quoteTypeClass += " quote_feature-student";
    quoteAuthor = React.createElement(QuoteFeatureStudent, {
      name: name,
      company: company,
      studentImageUrl: studentImageUrl
    });
  } else if (quoteType === "hero") {
    quoteTypeClass += " quote_hero";
  }
  return React.createElement("div", {
    className: quoteTypeClass
  }, React.createElement("div", {
    className: "quote__icon"
  }, React.createElement("p", null, "\u201D")), React.createElement("figure", {
    className: "quote__content"
  }, React.createElement("blockquote", null, React.createElement("p", {
    className: "quote__text"
  }, "\"", quote, "\"")), React.createElement("hr", {
    className: "quote__horizontal-line"
  }), quoteAuthor));
};
var ReviewStars = function (_a) {
  var rating = _a.rating;
  // eslint-disable-next-line prefer-const
  var starsList = [];
  for (var i = 0; i < rating; i++) {
    starsList.push(React.createElement("li", {
      key: i
    }, React.createElement(FontAwesomeIcon, {
      icon: faStar
    })));
  }
  return React.createElement("ul", {
    className: "scores__stars"
  }, starsList);
};
var CourseReportTile = function (_a) {
  var reviewTitle = _a.reviewTitle,
    reviewedAt = _a.reviewedAt,
    alumniName = _a.alumniName,
    alumniTitle = _a.alumniTitle,
    verified = _a.verified,
    overallScore = _a.overallScore,
    instructorScore = _a.instructorScore,
    curriculumScore = _a.curriculumScore,
    jobAssistanceScore = _a.jobAssistanceScore,
    reviewUrl = _a.reviewUrl,
    children = _a.children;
  var verifiedText;
  if (verified) {
    verifiedText = "Verified";
  }
  return React.createElement("article", {
    className: "review review_course-report"
  }, React.createElement("section", {
    className: "review__reviewer review__reviewer_course-report"
  }, React.createElement("section", {
    className: "reviewer__title"
  }, React.createElement("h4", null, reviewTitle), React.createElement("p", null, " - ", reviewedAt)), React.createElement("ul", {
    className: "reviewer__info reviewer__info_divide"
  }, React.createElement("li", {
    className: "reviewer__info_headline"
  }, alumniName), React.createElement("li", null, alumniTitle), React.createElement("li", null, "Graduate"), React.createElement("li", null, "Course: Immersive Full Stack Web Development Program"), React.createElement("li", null, "Campus: Boston"), React.createElement("li", null, verifiedText))), React.createElement("section", {
    className: "review__scores review__scores_course-report"
  }, React.createElement("div", {
    className: "scores__item"
  }, React.createElement("p", null, "Overall Experience:"), React.createElement(ReviewStars, {
    rating: overallScore
  })), React.createElement("div", {
    className: "scores__item"
  }, React.createElement("p", null, "Curriculum:"), React.createElement(ReviewStars, {
    rating: curriculumScore
  })), React.createElement("div", {
    className: "scores__item"
  }, React.createElement("p", null, "Instructors: "), React.createElement(ReviewStars, {
    rating: instructorScore
  })), React.createElement("div", {
    className: "scores__item"
  }, React.createElement("p", null, "Job Assistance: "), React.createElement(ReviewStars, {
    rating: jobAssistanceScore
  }))), React.createElement("section", {
    className: "review__narrative review__narrative_course-report"
  }, React.createElement("div", {
    className: "narrative__text"
  }, React.createElement("p", null, children)), React.createElement("div", {
    className: "narrative__read-more"
  }), React.createElement("a", {
    className: "narrative__link",
    href: reviewUrl
  }, React.createElement("button", {
    className: "link__button"
  }, "read more"))));
};
var css_248z = "@import url(\"https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;700&family=Roboto:wght@300;700&display=swap\");\n\n:root {\n  --course-report-background: #fff8e0;\n  --course-report-title: rgba(80, 146, 47, 0.65);\n  --course-report-text: #3f4549;\n  --course-report-border: #e5dec9;\n  --course-report-font-family: \"Roboto\", Arial, sans-serif;\n  --course-report-font-size: 15px;\n  --course-report-link: #50922f;\n  --course-report-link-size: 12px;\n  --switchup-link: #3a75ba;\n  --switchup-text: #4d4d4d;\n  --switchup-border: #ededed;\n  --switchup-font-size: 16px;\n  --switchup-font-family: \"Source Sans Pro\", sans-serif;\n}\n\n.review {\n  display: grid;\n  width: 100%;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n@media (min-width: 768px){\n  .review{\n    height: 20rem;\n    overflow: hidden;\n  }\n}\n\n.review_switchup {\n  border-width: 2px;\n  --tw-bg-opacity: 1;\n  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));\n  border-color: var(--switchup-border)\n}\n\n.review_switchup h4 {\n  font-size: var(--switchup-font-size);\n  font-family: var(--switchup-font-family);\n  color: var(--switchup-text);\n}\n\n.review_switchup p {\n  font-size: var(--switchup-font-size);\n  font-family: var(--switchup-font-family);\n  color: var(--switchup-text);\n}\n\n.review_course-report {\n  display: grid;\n  width: 100%;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  border-radius: 0.5rem;\n  border-width: 2px;\n  border-color: var(--course-report-border);\n  background-color: var(--course-report-background)\n}\n\n.review_course-report h4 {\n  margin-right: 0.25rem;\n  font-family: var(--course-report-font-family);\n  font-size: var(--course-report-font-size);\n}\n\n.review_course-report p {\n  font-family: var(--course-report-font-family);\n  font-size: var(--course-report-font-size);\n}\n\n.review_course-report li {\n  margin-left: 0.25rem;\n  font-family: var(--course-report-font-family);\n  font-size: var(--course-report-font-size);\n}\n\n.review__reviewer {\n  grid-column: span 2 / span 2;\n}\n\n.review__reviewer_switchup {\n  border-bottom-width: 2px;\n  padding: 1rem;\n  border-color: var(--switchup-border)\n}\n\n.review__reviewer_switchup .reviewer__name {\n  display: flex;\n  justify-content: space-between\n}\n\n.review__reviewer_switchup .reviewer__name h4 {\n  font-weight: 700;\n}\n\n.review__reviewer_course-report {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n  padding-bottom: 1.25rem\n}\n\n.review__reviewer_course-report .reviewer__title {\n  grid-column: span 2 / span 2;\n  display: inline-flex;\n  width: 100%;\n  align-items: baseline;\n  justify-content: flex-start;\n  padding-top: 1.25rem;\n}\n\n.review__reviewer_course-report .reviewer__info_divide li:nth-child(n + 2) {\n  list-style-type: disc;\n}\n\n.review__reviewer_course-report .reviewer__info {\n  display: inline-flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  font-family: Open Sans, sans-serif;\n  font-weight: 600\n}\n\n.review__reviewer_course-report .reviewer__info li {\n  margin-left: 0.75rem;\n  margin-right: 0.75rem;\n}\n\n.review__reviewer_course-report .reviewer__info li.reviewer__info_headline {\n  margin-left: -0.5rem;\n  color: var(--course-report-title);\n  font-family: var(--course-report-font-family);\n  font-size: var(--course-report-font-size);\n}\n\n.review__scores {\n  grid-column: span 2 / span 2;\n  display: inline-grid\n}\n\n.review__scores .scores__stars {\n  display: inline-flex;\n  --tw-text-opacity: 1;\n  color: rgba(255, 199, 89, var(--tw-text-opacity));\n}\n\n.review__scores_course-report {\n  column-gap: 2rem;\n  border-top-width: 2px;\n  border-bottom-width: 2px;\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem\n}\n\n@media (min-width: 768px){\n  .review__scores_course-report{\n    grid-column: span 2 / span 2;\n    display: inline-grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.review__scores_course-report{\n  border-color: var(--course-report-border);\n}\n\n.review__scores_course-report .scores__item {\n  grid-column: span 2 / span 2;\n  display: inline-flex;\n  justify-content: space-between;\n}\n\n@media (min-width: 768px){\n  .review__scores_course-report .scores__item{\n    grid-column: span 1 / span 1;\n  }\n}\n\n.review__scores_switchup {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  padding-left: 1rem;\n  padding-right: 1rem;\n  padding-top: 1rem;\n}\n\n.review__narrative {\n  grid-column: span 2 / span 2;\n}\n\n.review__narrative_switchup {\n  padding-left: 1rem;\n  padding-right: 1rem;\n  padding-bottom: 1rem\n}\n\n.review__narrative_switchup .narrative__title {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  font-weight: 700;\n}\n\n.review__narrative_switchup .narrative__text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding-top: 1rem;\n}\n\n.review__narrative_switchup .narrative__link {\n  text-transform: capitalize;\n  color: var(--switchup-link);\n  font-size: var(--switchup-font-size);\n  font-family: var(--switchup-font-family);\n}\n\n.review__narrative_course-report {\n  position: relative;\n  grid-column: span 2 / span 2;\n  max-height: 9rem;\n  width: 100%;\n  padding: 1.25rem\n}\n\n@media (min-width: 768px){\n  .review__narrative_course-report{\n    padding: 1.25rem;\n  }\n}\n\n.review__narrative_course-report .narrative__text {\n  z-index: 10;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n@media (min-width: 768px){\n  .review__narrative_course-report .narrative__text{\n    padding-bottom: 1.25rem;\n  }\n}\n\n.review__narrative_course-report .narrative__read-more {\n  position: absolute;\n  right: 0px;\n  bottom: 1.25rem;\n  left: 0px;\n  z-index: 20;\n  height: 100%;\n  width: auto;\n  background-image: linear-gradient(to top, var(--tw-gradient-stops));\n  --tw-gradient-from: var(--course-report-background);\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(0, 0, 0, 0));\n}\n\n.review__narrative_course-report .narrative__link {\n  position: absolute;\n  right: 0px;\n  bottom: 1.25rem;\n  left: 1.25rem;\n  z-index: 30;\n  margin-top: auto;\n  color: var(--course-report-link);\n  font-family: var(--course-report-font-family);\n  font-size: var(--course-report-link-size)\n}\n\n.review__narrative_course-report .narrative__link .link__button {\n  border-radius: 0.5rem;\n  border-width: 2px;\n  padding: 0.25rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  background-color: var(--course-report-background);\n}\n";
styleInject(css_248z);
var SwitchupReviewTile = function (_a) {
  var reviewTitle = _a.reviewTitle,
    reviewedAt = _a.reviewedAt,
    alumniName = _a.alumniName,
    alumniTitle = _a.alumniTitle,
    alumniGradYear = _a.alumniGradYear,
    overallScore = _a.overallScore,
    curriculumScore = _a.curriculumScore,
    jobAssistanceScore = _a.jobAssistanceScore,
    reviewUrl = _a.reviewUrl,
    children = _a.children;
  var alumniTitleCheck;
  if (alumniTitle) {
    alumniTitleCheck = " | ".concat(alumniTitle);
  }
  return React.createElement("article", {
    className: "review review_switchup"
  }, React.createElement("section", {
    className: "review__reviewer review__reviewer_switchup"
  }, React.createElement("div", {
    className: "reviewer__name"
  }, React.createElement("h4", null, alumniName, alumniTitleCheck), React.createElement("p", null, reviewedAt)), React.createElement("p", null, "18-Week On-Campus JavaScript Immersive Bootcamp"), React.createElement("p", null, "Graduated: ", alumniGradYear)), React.createElement("section", {
    className: "review__scores review__scores_switchup"
  }, React.createElement("div", null, React.createElement("p", null, "Overall Score"), React.createElement(ReviewStars, {
    rating: overallScore
  })), React.createElement("div", null, React.createElement("p", null, "Curriculum"), React.createElement(ReviewStars, {
    rating: curriculumScore
  })), React.createElement("div", null, React.createElement("p", null, "Job Support "), React.createElement(ReviewStars, {
    rating: jobAssistanceScore
  }))), React.createElement("section", {
    className: "review__narrative review__narrative_switchup"
  }, React.createElement("h4", {
    className: "narrative__title"
  }, reviewTitle), React.createElement("p", {
    className: "narrative__text"
  }, children), React.createElement("a", {
    className: "narrative__link",
    href: reviewUrl
  }, "read more")));
};
var ReviewList = function (_a) {
  var allReviews = _a.allReviews;
  var reviewsArray = allReviews.map(function (review) {
    if (review.reviewUrl.includes("coursereport.com")) {
      return React.createElement(CourseReportTile, {
        key: review.id,
        reviewTitle: review.reviewTitle,
        reviewedAt: review.reviewedAt,
        alumniName: review.alumniName,
        alumniTitle: review.alumniTitle,
        verified: review.verified,
        overallScore: review.overallScore,
        instructorScore: review.instructorScore,
        curriculumScore: review.curriculumScore,
        jobAssistanceScore: review.jobAssistanceScore,
        reviewUrl: review.reviewUrl
      }, review.reviewParagraph);
    }
    return React.createElement(SwitchupReviewTile, {
      key: review.id,
      reviewTitle: review.reviewTitle,
      reviewedAt: review.reviewedAt,
      alumniName: review.alumniName,
      alumniTitle: review.alumniTitle,
      alumniGradYear: review.alumniGradYear,
      verified: review.verified,
      overallScore: review.overallScore,
      curriculumScore: review.curriculumScore,
      jobAssistanceScore: review.jobAssistanceScore,
      reviewUrl: review.reviewUrl
    }, review.reviewParagraph);
  });
  return React.createElement("div", {
    className: "review-grid review-grid_stagger"
  }, reviewsArray);
};
var TitledParagraph = function (_a) {
  var title = _a.title,
    children = _a.children;
  return React.createElement("section", {
    className: "titled-paragraph"
  }, React.createElement("div", {
    className: "titled-paragraph__container"
  }, React.createElement("h3", {
    className: "titled-paragraph__title"
  }, title), children));
};
var fontFamily = {
  headline: ["Ubuntu", "sans-serif"],
  text: ["Open Sans", "sans-serif"],
  quote: ["Libre Baskerville", "serif"]
};
var fontSize = {
  xxs: [".75rem", {
    lineHeight: "1rem"
  }],
  xs: [".875rem", {
    lineHeight: "1.125rem"
  }],
  sm: ["1rem", {
    lineHeight: "1.33rem"
  }],
  base: ["1.125rem", {
    lineHeight: "1.3125rem"
  }],
  lg: ["1.25rem", {
    lineHeight: "1.5rem"
  }],
  xl: ["1.5rem", {
    lineHeight: "1.75rem"
  }],
  "2xl": ["2rem", {
    lineHeight: "2.25rem"
  }],
  "3xl": ["2.25rem", {
    lineHeight: "2.4rem"
  }],
  "4xl": ["2.75rem", {
    lineHeight: "2.8rem"
  }],
  "5xl": ["3rem", {
    lineHeight: "3.25rem"
  }],
  "6xl": ["3.75rem", {
    lineHeight: "4rem"
  }]
};
export { AccentCircle, BannerContent, BannerTitle, Button$1 as Button, Card, CardList, CreativeContent, DesktopDeviceTile, DesktopProjectCard, FaqList, HorizontalProfile, Icon, MobileDeviceTile, MobileProjectCard, Profile, Quote, ReviewList, SimpleBanner, TitledParagraph, TopBar, colors, fontFamily, fontSize };